import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";

/* ============================================================
   BANARAS BHANG — Vendor Registration Portal
   Vendor side: upload documents -> auto-fill -> submit
   Admin side : review submissions, open/download documents
   ============================================================ */

const LOGO_LIGHT = "data:image/png;base64,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";
const LOGO_DARK = "data:image/png;base64,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";

/* ---------------- brands ----------------
   One codebase serves a vendor form per brand. The brand comes from the URL
   (?brand=lobjet); everything brand-specific — logo, palette, reference
   prefix, the copy that names the company — is resolved from here.
   Submissions from every brand land in the same admin panel, tagged with
   the brand they were filed under. */

// Placeholder wordmark. Drop the real artwork in as a data URI or an import
// and swap it here — nothing else needs to change.
const lobjetMark = (color) =>
  "data:image/svg+xml;utf8," + encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214 56">` +
      `<g fill="${color}">` +
        `<rect x="18" y="4" width="12" height="4" rx="2"/>` +
        `<rect x="21.2" y="8" width="5.6" height="9"/>` +
        `<path d="M24 16c7.6 2.6 12.6 10.2 12.6 18.8C36.6 42.6 31.1 48 24 48s-12.6-5.4-12.6-13.2C11.4 26.2 16.4 18.6 24 16z"/>` +
        `<path d="M10.8 23.4c-3.6 1.6-5.1 5.2-4 8.8l2.6-.8c-.7-2.5.3-4.9 2.7-6.1z"/>` +
        `<path d="M37.2 23.4c3.6 1.6 5.1 5.2 4 8.8l-2.6-.8c.7-2.5-.3-4.9-2.7-6.1z"/>` +
        `<text x="60" y="42" font-family="Georgia, 'Times New Roman', serif" font-size="27" letter-spacing="4">L&#39;OBJET</text>` +
      `</g>` +
    `</svg>`
  );

const BRANDS = {
  banaras: {
    id: "banaras",
    name: "Banaras Bhang",
    logoLight: LOGO_LIGHT,
    logoDark: LOGO_DARK,
    refPrefix: "BB",
    // Domain shown on the dashboard's form link. Empty uses PUBLIC_ORIGIN.
    publicUrl: "https://vrf.banarasbhang.com",
    csvName: "banaras-bhang-vendors.csv",
    theme: {},
  },
  lobjet: {
    id: "lobjet",
    name: "L'OBJET",
    logoLight: lobjetMark("#FFFFFF"),
    logoDark: lobjetMark("#1B1815"),
    refPrefix: "LO",
    // Domain shown on the dashboard's form link. Empty uses PUBLIC_ORIGIN.
    publicUrl: "https://vrf.lobjet.in",
    csvName: "lobjet-vendors.csv",
    theme: {
      "--accent": "#A8873E",
      "--accent-dark": "#836829",
      "--accent-tint": "#F8F2E5",
      "--paper": "#F4F2EE",
      "--ochre": "#8C6D22",
      "--ochre-tint": "#F8F1E1",
    },
  },
};

const BRAND_IDS = Object.keys(BRANDS);
const DEFAULT_BRAND = "banaras";
// Records filed before the portal was multi-brand carry no brand field.
const brandOf = (v) => (BRANDS[v && v.brand] ? v.brand : DEFAULT_BRAND);

const ADMIN_PATH = "/admin";
// The admin panel is a separate URL, not a tab on the vendor form. Vendors who
// are sent a form link never see a way into procurement's side.
const isAdminUrl = () => {
  try {
    return window.location.pathname.replace(/\/+$/, "").toLowerCase() === ADMIN_PATH;
  } catch (e) { return false; }
};
// Public address shown on the dashboard's Copy Link / Open Form buttons, so a
// link copied from the panel on the office LAN still goes out as the real
// domain. Empty falls back to wherever the panel was opened.
const PUBLIC_ORIGIN = "https://vrf.banarasbhang.com";
const linkOrigin = () => PUBLIC_ORIGIN || window.location.origin;
const adminLink = () => linkOrigin() + ADMIN_PATH;

// Each brand has its own form URL. A path reads better on a shared link
// (/lobjet); ?brand= still works for anything already circulated.
const pathParts = () => window.location.pathname.replace(/^\/+|\/+$/g, "").toLowerCase().split("/");

function readBrandFromUrl() {
  try {
    const path = pathParts()[0];
    if (BRANDS[path]) return path;
    const q = String(new URLSearchParams(window.location.search).get("brand") || "").trim().toLowerCase();
    if (BRANDS[q]) return q;
    // A brand's own domain opens its form at the bare root, too.
    const host = window.location.hostname.toLowerCase();
    const byHost = BRAND_IDS.find((id) => hostOf(BRANDS[id].publicUrl) === host);
    return byHost || DEFAULT_BRAND;
  } catch (e) { return DEFAULT_BRAND; }
}
function hostOf(url) {
  try { return url ? new URL(url).hostname.toLowerCase() : ""; } catch (e) { return ""; }
}
const brandLink = (id, kind) =>
  (BRANDS[id].publicUrl || linkOrigin()).replace(/\/+$/, "") + "/" + id + (kind ? "/" + kind : "");

// Domestic or international vendor. /banaras opens a page to choose;
// /banaras/international (or /international on a brand's own domain) goes
// straight to that form, so a link can be sent to a foreign supplier as is.
const KINDS = ["domestic", "international"];
function readKindFromUrl() {
  try {
    const parts = pathParts();
    const k = BRANDS[parts[0]] ? parts[1] : parts[0];
    return KINDS.includes(k) ? k : null;
  } catch (e) { return null; }
}
const kindOf = (v) => ((v && v.data && v.data.vendorType) === "international" ? "international" : "domestic");

// navigator.clipboard needs a secure context; a plain-HTTP LAN address is not
// one, so fall back to a prompt the user can copy from.
function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).catch(() => window.prompt("Copy this link", text));
  } else window.prompt("Copy this link", text);
}

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Archivo:wght@600;700&family=Inter:wght@400;500;600;700&display=swap');

.cb, .cb *, .cb *::before, .cb *::after { box-sizing: border-box; }
.cb {
  --ink:#1B1815; --ink-2:#4A423B; --ink-3:#8A8078;
  --paper:#F3F1ED; --card:#FFFFFF; --line:#E5E0D9; --line-2:#F1EDE7;
  --accent:#8A5D3B; --accent-dark:#6A452B; --accent-tint:#F4ECE4;
  --ochre:#B67B00; --ochre-tint:#FDF4E3;
  --green:#1F7A55; --green-tint:#EAF6F0;
  --red:#B32B24; --red-tint:#FDEEED;
  --sans:'Inter',system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;
  --display:'Archivo','Inter',system-ui,sans-serif;
  --mono:ui-monospace,SFMono-Regular,'SF Mono',Menlo,Consolas,monospace;
  font-family:var(--sans); color:var(--ink); background:var(--paper);
  min-height:100vh; -webkit-font-smoothing:antialiased; font-size:15px; line-height:1.5;
}
.cb button, .cb input, .cb select, .cb textarea { font:inherit; color:inherit; }
.cb :focus-visible { outline:2px solid var(--accent); outline-offset:2px; border-radius:3px; }
@media (prefers-reduced-motion: reduce){ .cb *{ animation:none !important; transition:none !important; } }

/* ---------- shell ---------- */
.cb-top { position:sticky; top:0; z-index:40; background:var(--ink); color:#fff; }
.cb-top-in { max-width:1180px; margin:0 auto; padding:12px 16px; display:flex; align-items:center; gap:12px; }
.cb-mark { display:flex; align-items:center; gap:9px; margin-right:auto; min-width:0; }
.cb-logo { height:38px; width:auto; display:block; flex:none; }
.cb-logo-dark { height:52px; width:auto; display:block; }
.cb-mark-sub { font-size:10px; letter-spacing:.16em; text-transform:uppercase; color:#B5ACA1;
  padding-left:11px; margin-left:2px; border-left:1px solid rgba(255,255,255,.24); }
@media (max-width:430px){ .cb-logo { height:30px; } .cb-mark-sub { display:none; } }
.cb-printmark { display:none; }
/* ============================================================
   ADMIN SHELL
   ============================================================ */
.ad { display:flex; min-height:100vh; background:var(--paper); }

/* ---------- sidebar ---------- */
.ad-side { width:218px; flex:none; background:var(--ink); color:#CFC6BC; display:flex; flex-direction:column;
  position:sticky; top:0; height:100vh; overflow-y:auto; }
.ad-brandbox { padding:20px 18px 16px; display:flex; justify-content:center; }
.ad-brandbox img { max-width:150px; height:auto; display:block; }
.ad-navlabel { font-size:10px; letter-spacing:.16em; text-transform:uppercase; color:#8B8178;
  padding:6px 18px 8px; font-weight:600; }
.ad-nav { display:flex; flex-direction:column; gap:2px; padding:0 10px; }
.ad-navitem { display:flex; align-items:center; gap:11px; width:100%; border:0; background:transparent;
  color:#CFC6BC; padding:10px 12px; border-radius:9px; font-size:13.5px; font-weight:500; cursor:pointer;
  text-align:left; }
.ad-navitem:hover { background:rgba(255,255,255,.07); color:#fff; }
.ad-navitem[aria-current="true"] { background:var(--accent); color:#fff; font-weight:600; }
.ad-navitem .cnt { margin-left:auto; font-size:11px; font-weight:700; background:rgba(255,255,255,.14);
  padding:1px 7px; border-radius:999px; }
.ad-navitem[aria-current="true"] .cnt { background:rgba(0,0,0,.22); }
.ad-copy { margin-top:auto; padding:0 18px 18px; font-size:10.5px; color:#7C736B; line-height:1.5; }

/* ---------- topbar ---------- */
.ad-main { flex:1; min-width:0; display:flex; flex-direction:column; }
.ad-top { background:var(--card); border-bottom:1px solid var(--line); padding:0 22px;
  display:flex; align-items:center; gap:14px; height:63px; position:sticky; top:0; z-index:30; }
.ad-burger { border:0; background:transparent; color:var(--ink-2); cursor:pointer; padding:6px; line-height:0;
  border-radius:8px; display:none; }
.ad-burger:hover { background:var(--line-2); }
.ad-crumb { display:flex; align-items:center; gap:9px; font-size:13.5px; color:var(--ink-3); margin-right:auto; }
.ad-crumb b { color:var(--accent); font-weight:600; }
.ad-bell { position:relative; border:0; background:transparent; color:var(--ink-2); cursor:pointer;
  padding:7px; border-radius:8px; line-height:0; }
.ad-bell:hover { background:var(--line-2); }
.ad-bell .n { position:absolute; top:1px; right:1px; background:var(--red); color:#fff; font-size:10px;
  font-weight:700; min-width:16px; height:16px; border-radius:999px; display:grid; place-items:center; padding:0 4px; }
.ad-divider { width:1px; height:26px; background:var(--line); }
.ad-who { display:flex; align-items:center; gap:9px; border:0; background:transparent; cursor:pointer;
  padding:5px 8px; border-radius:9px; text-align:right; }
.ad-who:hover { background:var(--line-2); }
.ad-who b { display:block; font-size:13.5px; font-weight:600; color:var(--ink); }
.ad-who span { display:block; font-size:11.5px; color:var(--ink-3); }
.ad-menu { position:absolute; right:22px; top:58px; background:var(--card); border:1px solid var(--line);
  border-radius:11px; padding:6px; min-width:190px; box-shadow:0 12px 30px rgba(0,0,0,.12); z-index:40; }
.ad-menu button { display:block; width:100%; text-align:left; border:0; background:transparent;
  padding:9px 11px; border-radius:8px; font-size:13.5px; cursor:pointer; color:var(--ink); }
.ad-menu button:hover { background:var(--line-2); }
.ad-menu .hd { padding:8px 11px 6px; border-bottom:1px solid var(--line-2); margin-bottom:4px; }
.ad-menu .hd b { display:block; font-size:13.5px; }
.ad-menu .hd span { font-size:11.5px; color:var(--ink-3); }

/* ---------- page ---------- */
.ad-body { padding:24px 22px 48px; max-width:1420px; width:100%; }
.ad-head { display:flex; align-items:flex-start; gap:16px; margin-bottom:20px; flex-wrap:wrap; }
.ad-h1 { font-family:var(--display); font-size:27px; font-weight:700; letter-spacing:-.02em; margin:0 0 5px; }
.ad-sub { color:var(--ink-2); font-size:14px; margin:0; }

/* ---------- stat cards ---------- */
.ad-stats { display:grid; grid-template-columns:repeat(4,1fr); gap:14px; margin-bottom:20px; }
.ad-stat { background:var(--card); border:1px solid var(--line); border-radius:14px; padding:18px;
  display:flex; align-items:center; gap:14px; text-align:left; cursor:pointer; }
.ad-stat[aria-pressed="true"] { border-color:var(--accent); box-shadow:0 0 0 3px var(--accent-tint); }
.ad-stat .ico { width:46px; height:46px; border-radius:999px; display:grid; place-items:center; flex:none; }
.ad-stat b { display:block; font-family:var(--display); font-size:27px; line-height:1.1; font-weight:700; }
.ad-stat .lb { font-size:13px; font-weight:600; color:var(--ink); }
.ad-stat .sb { font-size:11.5px; color:var(--ink-3); }
.ico.blue { background:#EDF1F8; color:#3D5A85; }
.ico.amber { background:var(--ochre-tint); color:var(--ochre); }
.ico.green { background:var(--green-tint); color:var(--green); }
.ico.red { background:var(--red-tint); color:var(--red); }

/* ---------- two-column ---------- */
.ad-cols { display:grid; gap:16px; align-items:start; }
@media (min-width:1080px){ .ad-cols { grid-template-columns:370px minmax(0,1fr); } }
.ad-card { background:var(--card); border:1px solid var(--line); border-radius:14px; padding:18px; }
.ad-card + .ad-card { margin-top:16px; }
.ad-label { font-size:12.5px; font-weight:600; color:var(--ink-2); margin:0 0 8px; }

/* ---------- brand select ---------- */
.ad-brandsel { display:flex; align-items:center; gap:10px; width:100%; background:#fff;
  border:1px solid var(--line); border-radius:10px; padding:11px 12px; cursor:pointer; font-size:14px;
  font-weight:600; color:var(--ink); }
.ad-brandsel img { height:19px; width:auto; }
.ad-brandsel .cv { margin-left:auto; color:var(--ink-3); line-height:0; }
.ad-brandmenu { border:1px solid var(--line); border-radius:10px; overflow:hidden; margin-top:6px; }
.ad-brandmenu button { display:flex; align-items:center; gap:10px; width:100%; border:0; background:#fff;
  padding:10px 12px; cursor:pointer; font-size:13.5px; text-align:left; }
.ad-brandmenu button:hover { background:var(--line-2); }
.ad-brandmenu img { height:18px; width:auto; }

/* ---------- vendor list ---------- */
.ad-search { display:flex; align-items:center; gap:8px; background:#fff; border:1px solid var(--line);
  border-radius:10px; padding:0 11px; flex:1; min-width:0; }
.ad-search input { border:0; outline:0; padding:10px 0; width:100%; background:transparent; font-size:13.5px; }
.ad-iconbtn { border:1px solid var(--line); background:#fff; border-radius:10px; padding:9px; cursor:pointer;
  color:var(--ink-2); line-height:0; flex:none; }
.ad-iconbtn:hover { background:var(--line-2); }
.ad-iconbtn[aria-pressed="true"] { border-color:var(--accent); background:var(--accent-tint); color:var(--accent-dark); }
.ad-vlist { display:flex; flex-direction:column; gap:9px; margin-top:12px; }
.ad-vitem { width:100%; text-align:left; background:#fff; border:1px solid var(--line);
  border-left:3px solid transparent; border-radius:11px; padding:12px 13px; cursor:pointer; }
.ad-vitem:hover { background:var(--line-2); }
.ad-vitem[aria-current="true"] { border-color:var(--accent); border-left-color:var(--accent); background:var(--accent-tint); }
.ad-vitem .top { display:flex; align-items:center; gap:8px; }
.ad-vitem .nm { font-size:14px; font-weight:600; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.ad-vitem .meta { font-size:12px; color:var(--ink-3); margin-top:3px; }
.ad-pill { font-size:9.5px; font-weight:700; letter-spacing:.07em; text-transform:uppercase; padding:3px 7px;
  border-radius:5px; margin-left:auto; flex:none; }
.ad-pill.pending { background:var(--ochre-tint); color:var(--ochre); }
.ad-pill.approved { background:var(--green-tint); color:var(--green); }
.ad-pill.intl { background:#E8EEF9; color:#2A4F8F; }
.ad-pill.domestic { background:var(--line-2); color:var(--ink-2); }
.ad-pill.rejected { background:var(--red-tint); color:var(--red); }

/* Unread rows get a warm tint and a dot. Placed before the selected-row rule
   so opening one still reads as selected rather than unread. */
.ad-vitem.unread { background:var(--ochre-tint); border-color:#EAD9B4; }
.ad-vitem.unread .nm::after { content:""; display:inline-block; width:7px; height:7px; border-radius:999px;
  background:var(--ochre); margin-left:7px; vertical-align:middle; }
.ad-vitem[aria-current="true"] { border-color:var(--accent); border-left-color:var(--accent);
  background:var(--accent-tint); }

/* ---------- notifications ---------- */
.ad-notif { position:absolute; right:22px; top:58px; width:340px; max-width:calc(100vw - 32px);
  background:var(--card); border:1px solid var(--line); border-radius:12px; z-index:45;
  box-shadow:0 14px 34px rgba(0,0,0,.14); overflow:hidden; }
.ad-notif .hd { display:flex; align-items:center; gap:10px; padding:11px 13px;
  border-bottom:1px solid var(--line-2); }
.ad-notif .hd b { font-size:13.5px; margin-right:auto; }
.ad-notif .list { max-height:340px; overflow-y:auto; }
.ad-notif .row { display:block; width:100%; text-align:left; border:0; background:transparent;
  padding:11px 13px; cursor:pointer; border-bottom:1px solid var(--line-2); }
.ad-notif .row:hover { background:var(--line-2); }
.ad-notif .row b { display:block; font-size:13.5px; font-weight:600; }
.ad-notif .row span { font-size:11.5px; color:var(--ink-3); }
.ad-notif .none { padding:26px 16px; text-align:center; font-size:13px; color:var(--ink-3); }

/* ---------- detail ---------- */
.ad-dhead { display:flex; align-items:flex-start; gap:12px; flex-wrap:wrap; margin-bottom:10px; }
.ad-dhead h2 { font-family:var(--display); font-size:24px; font-weight:700; letter-spacing:-.02em; margin:0;
  margin-right:auto; }
.ad-dmeta { display:flex; align-items:center; gap:12px; flex-wrap:wrap; font-size:12.5px; color:var(--ink-3);
  margin-bottom:16px; }
.ad-strip { display:grid; grid-template-columns:repeat(auto-fit,minmax(130px,1fr)); background:#fff;
  border:1px solid var(--line); border-radius:12px; overflow:hidden; margin:0 0 16px; }
.ad-strip > div { padding:13px 15px; border-right:1px solid var(--line-2); min-width:0; }
.ad-strip > div:last-child { border-right:0; }
.ad-strip dt { font-size:10.5px; letter-spacing:.09em; text-transform:uppercase; color:var(--ink-3);
  font-weight:600; margin-bottom:4px; }
.ad-strip dd { margin:0; font-size:13.5px; font-weight:600; overflow:hidden; text-overflow:ellipsis;
  white-space:nowrap; }
.ad-split { display:grid; gap:16px; align-items:start; }
/* Side by side only when the record itself has room — the vendor list beside
   it eats 370px, so the window width alone squeezed Details into ~280px. */
.ad-record { container-type:inline-size; }
@container (min-width:860px){ .ad-split { grid-template-columns:300px minmax(0,1fr); } }

/* ---------- approval timeline ---------- */
.ad-chain { list-style:none; margin:0; padding:0; }
.ad-chain li { display:flex; gap:12px; padding-bottom:20px; position:relative; }
.ad-chain li:last-child { padding-bottom:0; }
.ad-chain li::before { content:""; position:absolute; left:11px; top:26px; bottom:2px; width:2px;
  background:var(--line); }
.ad-chain li:last-child::before { display:none; }
.ad-chain li.done::before { background:var(--green); }
.ad-chain .mk { width:24px; height:24px; border-radius:999px; display:grid; place-items:center; flex:none;
  background:var(--line-2); color:var(--ink-3); z-index:1; }
.ad-chain li.done .mk { background:var(--green); color:#fff; }
.ad-chain li.no .mk { background:var(--red); color:#fff; }
.ad-chain li.now .mk { background:var(--ochre); color:#fff; box-shadow:0 0 0 3px var(--ochre-tint); }
.ad-chain .ttl { font-size:13.5px; font-weight:600; display:flex; align-items:center; gap:7px; flex-wrap:wrap; }
.ad-chain .you { font-size:9px; font-weight:700; letter-spacing:.08em; background:var(--accent-tint);
  color:var(--accent-dark); padding:2px 6px; border-radius:4px; }
.ad-chain .when { font-size:12px; color:var(--ink-3); margin-top:3px; }
.ad-chain .why { font-size:12px; margin-top:4px; color:var(--ink-2); }
.ad-chain .why i { color:var(--red); font-style:normal; }

/* ---------- tabs ---------- */
.ad-tabs { display:flex; gap:22px; border-bottom:1px solid var(--line); margin:0 0 16px; }
.ad-tabs button { border:0; background:transparent; padding:11px 0; cursor:pointer; font-size:13.5px;
  font-weight:600; color:var(--ink-3); border-bottom:2px solid transparent; margin-bottom:-1px; }
.ad-tabs button[aria-selected="true"] { color:var(--accent); border-bottom-color:var(--accent); }
.ad-blank { border:1px dashed var(--line); border-radius:12px; padding:44px 20px; text-align:center; }
.ad-blank .ico { width:56px; height:56px; border-radius:999px; background:var(--line-2); color:var(--ink-3);
  display:grid; place-items:center; margin:0 auto 12px; }
.ad-blank b { display:block; font-size:14px; font-weight:600; margin-bottom:4px; }
.ad-blank span { font-size:12.5px; color:var(--ink-3); }

/* ---------- responsive ---------- */
@media (max-width:1000px){
  /* No transition here on purpose: crossing this breakpoint on an already
     mounted sidebar leaves the transform mid-flight, so the panel can sit
     open over the content with no scrim to dismiss it. Snapping is correct
     every time. */
  .ad-side { position:fixed; left:0; top:0; z-index:60; transform:translateX(-100%);
    box-shadow:0 0 40px rgba(0,0,0,.3); }
  .ad-side.open { transform:none; }
  .ad-burger { display:block; }
  .ad-scrim { position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:55; }
}
@media (max-width:760px){
  .ad-stats { grid-template-columns:1fr 1fr; }
  .ad-who b, .ad-who span { display:none; }
}

@media print { .cb-printmark { display:block; margin-bottom:14px; } }
.cb-wrap { max-width:1180px; margin:0 auto; padding:20px 16px 72px; }
.cb-narrow { max-width:680px; margin:0 auto; padding:20px 16px 100px; }

/* ---------- type ---------- */
.cb-h1 { font-family:var(--display); font-size:29px; line-height:1.15; margin:0 0 6px; font-weight:700; letter-spacing:-.022em; }
.cb-h2 { font-family:var(--display); font-size:21px; line-height:1.2; margin:0 0 4px; font-weight:700; letter-spacing:-.018em; }
.cb-lede { color:var(--ink-2); margin:0 0 20px; font-size:14.5px; }
.cb-eyebrow { font-size:10.5px; letter-spacing:.18em; text-transform:uppercase; color:var(--ink-3); font-weight:600; }
.cb-mono { font-family:var(--mono); letter-spacing:.04em; }

/* ---------- swatch rail (signature) ---------- */
.cb-rail { display:flex; gap:4px; margin:0 0 10px; }
.cb-rail i { flex:1; height:9px; border-radius:2px; background:var(--line); display:block; transition:background .25s ease; }
.cb-rail i.on { background:var(--accent); }
.cb-rail i.now { background:var(--accent); box-shadow:0 0 0 3px var(--accent-tint); }
.cb-railcap { display:flex; justify-content:space-between; align-items:baseline; margin-bottom:16px; }

/* ---------- cards & fields ---------- */
.cb-card { background:var(--card); border:1px solid var(--line); border-radius:14px; padding:18px; margin-bottom:14px; }
.cb-choices { display:grid; gap:14px; margin:4px 0 16px; }
@media (min-width:640px){ .cb-choices { grid-template-columns:1fr 1fr; } }
.cb-choice { display:flex; flex-direction:column; gap:8px; text-align:left; font:inherit; color:inherit; cursor:pointer;
  background:var(--card); border:1px solid var(--line); border-radius:14px; padding:20px 18px; transition:border-color .15s, box-shadow .15s; }
.cb-choice:hover, .cb-choice:focus-visible { border-color:var(--accent); box-shadow:0 0 0 3px var(--accent-tint); outline:none; }
.cb-choice-t { font-size:18px; font-weight:700; }
.cb-choice-l { font-size:14px; color:var(--ink-2); }
.cb-choice-n { font-size:12.5px; color:var(--ink-3); line-height:1.5; flex:1; }
.cb-choice-go { display:inline-flex; align-items:center; gap:6px; font-size:13.5px; font-weight:700; color:var(--accent); margin-top:4px; }
.cb-card-h { display:flex; align-items:center; gap:10px; margin-bottom:14px; }
.cb-grid { display:grid; gap:13px; }
@media (min-width:620px){ .cb-grid.two { grid-template-columns:1fr 1fr; } .cb-span { grid-column:1/-1; } }

.cb-f { display:flex; flex-direction:column; gap:5px; min-width:0; }
.cb-f label { font-size:11.5px; font-weight:600; letter-spacing:.05em; text-transform:uppercase; color:var(--ink-2);
  display:flex; align-items:center; gap:6px; }
.cb-f label .req { color:var(--accent); }
.cb-f input, .cb-f select, .cb-f textarea {
  width:100%; padding:11px 12px; border:1px solid var(--line); border-radius:9px; background:#fff;
  font-size:15px; -webkit-appearance:none; appearance:none; }
.cb-f select { background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8'><path d='M1 1l5 5 5-5' stroke='%238A8078' stroke-width='1.6' fill='none' stroke-linecap='round'/></svg>");
  background-repeat:no-repeat; background-position:right 12px center; padding-right:34px; }
.cb-f textarea { min-height:80px; resize:vertical; }
.cb-f input.code { font-family:var(--mono); letter-spacing:.08em; text-transform:uppercase; }
.cb-f .err { font-size:12px; color:var(--red); }
.cb-f input[aria-invalid="true"], .cb-f select[aria-invalid="true"] { border-color:var(--red); background:var(--red-tint); }
.cb-hint { font-size:12px; color:var(--ink-3); }

.cb-auto { font-size:9.5px; font-weight:700; letter-spacing:.1em; text-transform:uppercase;
  color:var(--accent); background:var(--accent-tint); padding:2px 6px; border-radius:4px; }

/* choice chips */
.cb-chips { display:flex; flex-wrap:wrap; gap:7px; }
.cb-chips button { border:1px solid var(--line); background:#fff; padding:9px 13px; border-radius:999px;
  font-size:13.5px; cursor:pointer; }
.cb-chips button[aria-pressed="true"] { border-color:var(--accent); background:var(--accent-tint);
  color:var(--accent-dark); font-weight:600; }

/* ---------- buttons ---------- */
.cb-btn { display:inline-flex; align-items:center; justify-content:center; gap:8px; border:1px solid transparent;
  padding:12px 18px; border-radius:10px; font-size:14.5px; font-weight:600; cursor:pointer; background:var(--accent); color:#fff; }
.cb-btn:hover { background:var(--accent-dark); }
.cb-btn:disabled { opacity:.5; cursor:not-allowed; }
.cb-btn.ghost { background:#fff; color:var(--ink); border-color:var(--line); }
.cb-btn.ghost:hover { background:var(--line-2); }
.cb-btn.sm { padding:8px 13px; font-size:13px; border-radius:8px; }
.cb-btn.wide { width:100%; }
.cb-navbar { display:flex; gap:10px; margin-top:18px; }
.cb-navbar .grow { flex:1; }

/* ---------- upload ---------- */
.cb-drop { border:1.5px dashed #D8CEC1; border-radius:14px; background:#fff; padding:26px 18px; text-align:center; }
.cb-drop.over { border-color:var(--accent); background:var(--accent-tint); }
.cb-drop h3 { font-family:var(--display); font-weight:700; font-size:18px; letter-spacing:-.015em; margin:10px 0 4px; }
.cb-drop p { color:var(--ink-3); font-size:13px; margin:0 0 14px; }
.cb-filelist { display:flex; flex-direction:column; gap:8px; margin-top:14px; }
.cb-file { display:flex; align-items:center; gap:11px; background:#fff; border:1px solid var(--line);
  border-radius:11px; padding:10px 11px; }
.cb-file .ico { width:34px; height:34px; border-radius:8px; background:var(--accent-tint); color:var(--accent);
  display:grid; place-items:center; flex:none; }
.cb-file .meta { min-width:0; flex:1; }
.cb-file .nm { font-size:13.5px; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.cb-file .sub { font-size:11.5px; color:var(--ink-3); }
.cb-file select { border:1px solid var(--line); border-radius:7px; padding:5px 7px; font-size:12px; background:#fff; max-width:130px; }
.cb-x { border:0; background:transparent; color:var(--ink-3); cursor:pointer; padding:6px; line-height:0; }
.cb-x:hover { color:var(--red); }

/* ---------- reading state ---------- */
.cb-reading { display:flex; align-items:center; gap:12px; background:var(--ink); color:#fff;
  border-radius:12px; padding:14px 16px; margin-top:14px; }
.cb-pulse { display:flex; gap:3px; }
.cb-pulse i { width:5px; height:18px; border-radius:1px; background:var(--accent); animation:cbp 1s ease-in-out infinite; }
.cb-pulse i:nth-child(2){ animation-delay:.12s; background:#A87A52; }
.cb-pulse i:nth-child(3){ animation-delay:.24s; background:#C6A583; }
.cb-pulse i:nth-child(4){ animation-delay:.36s; background:#E0CBB0; }
@keyframes cbp { 0%,100%{ transform:scaleY(.45); opacity:.6 } 50%{ transform:scaleY(1); opacity:1 } }

/* ---------- notes ---------- */
.cb-note { border-radius:11px; padding:12px 14px; font-size:13.5px; display:flex; gap:10px; align-items:flex-start; }
.cb-note.ok { background:var(--green-tint); color:#14563B; }
.cb-note.warn { background:var(--ochre-tint); color:#7A5300; }
.cb-note.bad { background:var(--red-tint); color:#8C221C; }
.cb-note.info { background:var(--accent-tint); color:var(--accent-dark); }
.cb-note b { font-weight:700; }
.cb-textlink { display:block; margin-left:auto; margin-right:auto; background:none; border:0; padding:4px; font:inherit;
  font-size:13px; font-weight:600; color:var(--accent); text-decoration:underline; cursor:pointer; }
.cb-textlink:hover { color:var(--accent-dark); }

/* ---------- review ---------- */
.cb-rows { border-top:1px solid var(--line-2); }
.cb-row { display:flex; gap:14px; padding:9px 0; border-bottom:1px solid var(--line-2); font-size:14px; }
.cb-row dt { flex:none; width:44%; max-width:220px; color:var(--ink-3); font-size:12.5px; }
.cb-row dd { margin:0; flex:1; min-width:0; word-break:break-word; }
.cb-row dd.empty { color:var(--ink-3); font-style:italic; }

/* ---------- admin ---------- */
.cb-stats { display:grid; grid-template-columns:repeat(4,1fr); gap:9px; margin-bottom:18px; }
.cb-stat { background:var(--card); border:1px solid var(--line); border-radius:12px; padding:12px 11px; }
.cb-stat b { display:block; font-family:var(--display); font-size:26px; line-height:1.1; font-weight:700; letter-spacing:-.02em; }
.cb-stat span { font-size:10.5px; letter-spacing:.1em; text-transform:uppercase; color:var(--ink-3); font-weight:600; }
.cb-toolbar { display:flex; gap:8px; flex-wrap:wrap; margin-bottom:14px; }
.cb-search { flex:1; min-width:180px; display:flex; align-items:center; gap:8px; background:#fff;
  border:1px solid var(--line); border-radius:10px; padding:0 12px; }
.cb-search input { border:0; outline:0; padding:11px 0; width:100%; background:transparent; }
.cb-split { display:grid; gap:16px; }
@media (min-width:900px){ .cb-split { grid-template-columns:380px 1fr; align-items:start; } }
.cb-list { display:flex; flex-direction:column; gap:9px; }
.cb-item { display:flex; gap:12px; text-align:left; width:100%; background:var(--card); border:1px solid var(--line);
  border-radius:12px; padding:13px; cursor:pointer; }
.cb-item[aria-current="true"] { border-color:var(--accent); box-shadow:0 0 0 3px var(--accent-tint); }
.cb-docrail { display:flex; flex-direction:column; gap:3px; flex:none; padding-top:2px; }
.cb-docrail i { width:5px; height:11px; border-radius:1px; background:var(--line); display:block; }
.cb-docrail i.on { background:var(--accent); }
.cb-item .nm { font-weight:600; font-size:14.5px; }
.cb-item .sub { font-size:12px; color:var(--ink-3); margin-top:2px; }
.cb-tag { font-size:10px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; padding:3px 7px; border-radius:5px; }
.cb-tag.pending { background:var(--ochre-tint); color:var(--ochre); }
.cb-tag.approved { background:var(--green-tint); color:var(--green); }
.cb-tag.rejected { background:var(--red-tint); color:var(--red); }
.cb-empty { background:var(--card); border:1px dashed var(--line); border-radius:12px; padding:30px 18px; text-align:center; color:var(--ink-3); }
.cb-doc { display:flex; align-items:center; gap:11px; border:1px solid var(--line); border-radius:11px; padding:10px 11px; }
.cb-tabs { display:flex; gap:4px; border-bottom:1px solid var(--line); margin-bottom:16px; }
.cb-tabs button { border:0; background:transparent; padding:10px 4px; margin-right:16px; cursor:pointer;
  font-size:13.5px; font-weight:600; color:var(--ink-3); border-bottom:2px solid transparent; }
.cb-tabs button[aria-selected="true"] { color:var(--accent); border-bottom-color:var(--accent); }
.cb-back { display:none; }
@media (max-width:899px){ .cb-back { display:inline-flex; } .cb-hide-mobile { display:none !important; } }

.cb-foot { max-width:1180px; margin:0 auto; padding:0 16px 40px; font-size:12px; color:var(--ink-3); }

/* ---------- approval matrix ---------- */
.cb-dots { display:flex; gap:3px; flex:none; }
.cb-dots i { width:14px; height:5px; border-radius:2px; background:var(--line); display:block; }
.cb-dots i.ok { background:var(--green); }
.cb-dots i.no { background:var(--red); }

/* ---------- brand switch (admin) ---------- */
.cb-brandbar { display:flex; gap:8px; flex-wrap:wrap; margin:0 0 16px; }
.cb-brandbtn { display:flex; align-items:center; gap:10px; background:var(--card); border:1px solid var(--line);
  border-radius:12px; padding:9px 14px; cursor:pointer; text-align:left; }
.cb-brandbtn img { height:20px; width:auto; display:block; flex:none; }
.cb-brandbtn .n { font-size:12px; color:var(--ink-3); font-weight:600; white-space:nowrap; }
.cb-brandbtn[aria-pressed="true"] { border-color:var(--accent); background:var(--accent-tint);
  box-shadow:0 0 0 3px var(--accent-tint); }
.cb-brandbtn[aria-pressed="true"] .n { color:var(--accent-dark); }

/* ---------- shareable form links (admin) ---------- */
.cb-links { display:flex; flex-direction:column; gap:7px; margin:0 0 18px; }
.cb-link { display:flex; align-items:center; gap:10px; flex-wrap:wrap; background:var(--card);
  border:1px solid var(--line); border-radius:10px; padding:9px 12px; font-size:12.5px; }
.cb-link .who { font-weight:700; flex:none; }
.cb-link code { font-family:var(--mono); font-size:12px; color:var(--ink-2); word-break:break-all; flex:1; min-width:0; }

@media print {
  .cb-top, .cb-toolbar, .cb-stats, .cb-list, .cb-tabs, .cb-noprint, .cb-foot, .cb-brandbar, .cb-links,
  .ad-side, .ad-top, .ad-stats, .ad-head, .ad-tabs, .ad-scrim, .ad-menu { display:none !important; }
  .ad, .ad-cols, .ad-split { display:block; } .ad-body { padding:0; }
  .cb-split { display:block; } .cb { background:#fff; }
  .cb-card { border:1px solid #999; break-inside:avoid; }
}
`;

/* ---------------- icons ---------------- */
const I = {
  up: (p) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M12 16V4M7 9l5-5 5 5M4 16v3a1 1 0 001 1h14a1 1 0 001-1v-3" /></svg>,
  file: (p) => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M14 3H7a1 1 0 00-1 1v16a1 1 0 001 1h10a1 1 0 001-1V7z" /><path d="M14 3v4h4" /></svg>,
  x: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" {...p}><path d="M6 6l12 12M18 6L6 18" /></svg>,
  check: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M4 12.5l5 5L20 6" /></svg>,
  search: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" {...p}><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>,
  down: (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M12 4v12M7 11l5 5 5-5M5 20h14" /></svg>,
  left: (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M14 6l-6 6 6 6" /></svg>,
  right: (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M10 6l6 6-6 6" /></svg>,
  eye: (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z" /><circle cx="12" cy="12" r="2.6" /></svg>,
  menu: (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" {...p}><path d="M4 7h16M4 12h16M4 17h16" /></svg>,
  bell: (p) => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M18 8A6 6 0 006 8c0 7-3 8-3 8h18s-3-1-3-8" /><path d="M13.7 21a2 2 0 01-3.4 0" /></svg>,
  chev: (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M6 9l6 6 6-6" /></svg>,
  home: (p) => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M3 10.5L12 3l9 7.5" /><path d="M5 9.5V20h14V9.5" /></svg>,
  people: (p) => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="9" cy="8" r="3.2" /><path d="M2.5 20c0-3.4 2.9-5.5 6.5-5.5s6.5 2.1 6.5 5.5" /><path d="M17 7.5a3 3 0 010 6M18 14.6c2.1.7 3.5 2.3 3.5 4.4" /></svg>,
  clip: (p) => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="5" y="4" width="14" height="17" rx="2" /><path d="M9 3h6v3H9z" /><path d="M9 11h6M9 15h4" /></svg>,
  stamp: (p) => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="9" /><path d="M8 12.5l2.6 2.6L16 9.5" /></svg>,
  folder: (p) => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M3 7a1 1 0 011-1h5l2 2.5h8a1 1 0 011 1V18a1 1 0 01-1 1H4a1 1 0 01-1-1z" /></svg>,
  link: (p) => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M10 13.5a4 4 0 006 .5l2-2a4 4 0 00-5.7-5.7L11 7.5" /><path d="M14 10.5a4 4 0 00-6-.5l-2 2a4 4 0 005.7 5.7L13 16.5" /></svg>,
  ext: (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M14 4h6v6" /><path d="M20 4l-9 9" /><path d="M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5" /></svg>,
  hourglass: (p) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M7 3h10M7 21h10" /><path d="M8 3v3.5c0 2 4 3.6 4 5.5s-4 3.5-4 5.5V21" /><path d="M16 3v3.5c0 2-4 3.6-4 5.5s4 3.5 4 5.5V21" /></svg>,
  checkc: (p) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="9.2" /><path d="M8 12.4l2.7 2.7L16.2 9.6" /></svg>,
  xc: (p) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" {...p}><circle cx="12" cy="12" r="9.2" /><path d="M9 9l6 6M15 9l-6 6" /></svg>,
  circle: (p) => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" {...p}><circle cx="12" cy="12" r="8" /></svg>,
  plus: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" {...p}><path d="M12 5v14M5 12h14" /></svg>,
  printer: (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M7 9V3h10v6" /><rect x="4" y="9" width="16" height="7" rx="1.5" /><path d="M7 14h10v7H7z" /></svg>,
  trash: (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" /></svg>,
  filter: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M3 5h18l-7 8v6l-4 2v-8z" /></svg>,
  cog: (p) => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="3.2" /><path d="M12 2.8v2.6M12 18.6v2.6M4.6 4.6l1.9 1.9M17.5 17.5l1.9 1.9M2.8 12h2.6M18.6 12h2.6M4.6 19.4l1.9-1.9M17.5 6.5l1.9-1.9" /></svg>,
  lock: (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="4" y="10" width="16" height="10" rx="2" /><path d="M8 10V7a4 4 0 018 0v3" /></svg>,
};

/* ---------------- server API ----------------
   Registrations live in SQLite behind /api, not in the browser, so every
   submission reaches the one admin panel no matter which device filed it.
   Admin routes ride an httpOnly session cookie — `credentials: "same-origin"`
   is what sends it. */
const OFFLINE_MSG = "Cannot reach the server. Start it with “npm run server”, then try again.";

async function api(path, options = {}) {
  let r;
  try {
    r = await fetch("/api" + path, {
      credentials: "same-origin",
      headers: options.body ? { "Content-Type": "application/json" } : undefined,
      ...options,
    });
  } catch (e) {
    throw new Error(OFFLINE_MSG);
  }
  if (r.status === 204) return null;

  let payload = null;
  try { payload = await r.json(); } catch (e) { /* non-JSON body */ }

  if (!r.ok) {
    if (payload && payload.error) {
      const err = new Error(payload.error);
      err.status = r.status;
      err.restart = !!payload.restart;   // sign-in: start again from the password
      throw err;
    }
    // The API answers everything it owns in JSON; a non-JSON 5xx means the
    // request never got there.
    if (r.status >= 500) throw new Error(OFFLINE_MSG);
    const err = new Error("Request failed (" + r.status + ").");
    err.status = r.status;
    throw err;
  }
  return payload;
}

const registry = {
  submit: (payload) => api("/vendors", { method: "POST", body: JSON.stringify(payload) }),
  list: () => api("/vendors").then((r) => r.vendors),
  decide: (id, decision, note) =>
    api("/vendors/" + encodeURIComponent(id) + "/decision",
      { method: "POST", body: JSON.stringify({ decision, note }) }).then((r) => r.vendor),
  remove: (id) => api("/vendors/" + encodeURIComponent(id), { method: "DELETE" }),
  markRead: (id) => api("/vendors/" + encodeURIComponent(id) + "/read", { method: "POST" }),
  markAllRead: () => api("/vendors/read-all", { method: "POST" }),
  documentUrl: (vendorId, docId, download) =>
    "/api/vendors/" + encodeURIComponent(vendorId) + "/documents/" + encodeURIComponent(docId) +
    (download ? "?download=1" : ""),
  // Password step. Answers { step: "code" | "setup", pending, … } — never a
  // session on its own; verifyLogin() finishes with the authenticator code.
  login: (username, password) =>
    api("/admin/login", { method: "POST", body: JSON.stringify({ username, password }) }),
  verifyLogin: (pending, code) =>
    api("/admin/login/verify", { method: "POST", body: JSON.stringify({ pending, code }) }),
  resetTotp: (username) => api("/users/" + encodeURIComponent(username) + "/totp/reset", { method: "POST" }),
  logout: () => api("/admin/logout", { method: "POST" }),
  forgotPassword: (identifier) =>
    api("/admin/forgot", { method: "POST", body: JSON.stringify({ identifier }) }),
  checkReset: (token) => api("/admin/reset/check", { method: "POST", body: JSON.stringify({ token }) }),
  resetWithLink: (token, password) =>
    api("/admin/reset", { method: "POST", body: JSON.stringify({ token, password }) }),
  session: () => api("/admin/session"),
  users: () => api("/users").then((r) => r.users),
  directory: () => api("/users"),   // { users, departments, chain, roles }
  addDepartment: (name, position) =>
    api("/departments", { method: "POST", body: JSON.stringify({ name, position }) }),
  moveDepartment: (name, position) =>
    api("/departments/" + encodeURIComponent(name), { method: "PATCH", body: JSON.stringify({ position }) }),
  removeDepartment: (name) =>
    api("/departments/" + encodeURIComponent(name), { method: "DELETE" }),
  createUser: (u) => api("/users", { method: "POST", body: JSON.stringify(u) }).then((r) => r.user),
  updateUser: (username, patch) =>
    api("/users/" + encodeURIComponent(username), { method: "PATCH", body: JSON.stringify(patch) })
      .then((r) => r.user),
  resetPassword: (username, password) =>
    api("/users/" + encodeURIComponent(username) + "/password",
      { method: "POST", body: JSON.stringify({ password }) }),
  changeOwnPassword: (username, currentPassword, password) =>
    api("/users/" + encodeURIComponent(username) + "/password",
      { method: "POST", body: JSON.stringify({ currentPassword, password }) }),
  removeUser: (username) =>
    api("/users/" + encodeURIComponent(username), { method: "DELETE" }),
};

/* ---------------- constants ---------------- */
const DOC_TYPES = ["GST certificate", "PAN card", "Cancelled cheque", "Udyam / MSME certificate",
  "ISO / ISI certificate", "Incorporation / registration", "Signed declaration", "Other"];
// The six documents procurement needs from an international vendor, in the
// order they ask for them; the documents step shows them as a checklist.
const DOCS_REQUIRED_INTL = ["Business License", "Bank Account Certificate", "TIN certificate",
  "Foreign Trade Registration Certificate", "Quality & Compliance Certificates", "Purchase Contract"];
const DOC_TYPES_INTL = [...DOCS_REQUIRED_INTL,
  "Tax residency certificate (TRC)", "No PE declaration", "PAN card", "Signed declaration", "Other"];
const NATURE_BUSINESS = ["Manufacturing", "Sole selling agent", "Dealer", "Trader", "Agent", "Assembler"];
const NATURE_COMPANY = ["Proprietary", "Partnership", "Private Ltd.", "Public Ltd.", "Foreign company"];
const SIZES = ["Micro", "Small", "Medium", "Large"];
const STEPS = ["Documents", "Company", "Contacts", "Tax", "Bank", "Review"];
const MAX_FILE_BYTES = 8 * 1024 * 1024;

// Only these ever reach a Blob. A vendor-supplied "text/html" opened from the
// admin view would run as this origin, so the type is allowlisted on the way
// in (addFiles) and enforced again by the server on submit.
const ALLOWED_MIME = /^(application\/pdf|image\/(png|jpeg|gif|webp|heic|heif))$/;
const EXT_MIME = {
  pdf: "application/pdf", png: "image/png", jpg: "image/jpeg", jpeg: "image/jpeg",
  gif: "image/gif", webp: "image/webp", heic: "image/heic", heif: "image/heif",
};
// Browsers leave type empty on some drag-and-drop files; fall back to the
// extension, and return null when we still cannot vouch for it.
const safeMime = (file) => {
  const t = String(file.type || "").toLowerCase().trim();
  if (t === "image/jpg") return "image/jpeg";
  if (ALLOWED_MIME.test(t)) return t;
  return EXT_MIME[file.name.toLowerCase().split(".").pop()] || null;
};

// International vendors (BB "Vendor Registration Form — international") give a
// VAT number instead of GSTIN, PAN only with a PE in India, and SWIFT / IBAN
// plus the banker's address instead of IFSC.
const blank = (kind = "domestic") => ({
  vendorType: kind,
  firmName: "", address: "", city: "", state: "", pincode: "", country: kind === "international" ? "" : "India",
  vatNo: "", vatDate: "", bankAddress: "", bankCountry: "",
  email: "", mobile: "", phone: "", fax: "", website: "",
  people: [{ name: "", designation: "", qualification: "", phone: "", place: "" }],
  natureBusiness: "", natureCompany: "", isForeign: kind === "international" ? "yes" : "no", peStatus: "",
  size: "", udyamNo: "", udyamDate: "",
  gstNo: "", gstDate: "", gstDealer: kind === "international" ? "" : "Regular",
  panNo: "", panDate: "",
  itSection: "", itExNo: "", itExRate: "", itExFrom: "", itExTo: "",
  relation: "",
  certified: "no", certTypes: "", certInProcess: "no", certExpected: "",
  items: "", reason: "",
  bankName: "", bankAccount: "", ifsc: "", accountHolder: "", branch: "", swift: "", iban: "",
  declPlace: "", declDate: new Date().toISOString().slice(0, 10), agreed: false, signatory: "",
});

/* ---------------- validation ---------------- */
const RX = {
  gst: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  pan: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
  ifsc: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
  mobile: /^[0-9]{10}$/,
  // International: digits with an optional +, spaces, dashes or brackets.
  intlPhone: /^\+?[0-9][0-9 ()-]{6,19}$/,
  swift: /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
  iban: /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/,
};
function intlStepErrors(step, d) {
  const e = {};
  const need = (k, msg) => { if (!String(d[k] || "").trim()) e[k] = msg || "Required"; };
  const up = (k) => String(d[k] || "").toUpperCase().replace(/\s/g, "");
  if (step === 1) {
    need("firmName", "Enter the firm's registered name");
    need("address", "Enter the full address");
    need("city"); need("country", "Enter the country");
  }
  if (step === 2) {
    need("email"); if (d.email && !RX.email.test(d.email)) e.email = "Check the email address";
    need("mobile", "Enter a number with its country code");
    if (d.mobile && !RX.intlPhone.test(d.mobile.trim())) e.mobile = "Country code and number, e.g. +44 7700 900123";
    if (d.phone && !RX.intlPhone.test(d.phone.trim())) e.phone = "Country code, area code and number, e.g. +44 20 7946 0000";
    if (!d.people[0] || !d.people[0].name.trim()) e.person0 = "Add at least one contact person";
    need("items", "List what you supply");
  }
  if (step === 3) {
    need("peStatus", "Confirm your PE status");
    need("vatNo", "Enter your VAT / TIN number");
    if (d.peStatus === "yes") {
      need("panNo", "PAN is required when you have a PE in India");
    }
    if (d.panNo && !RX.pan.test(up("panNo"))) e.panNo = "Format ABCDE1234F";
  }
  if (step === 4) {
    need("bankName"); need("bankAddress", "Enter the bank's address"); need("accountHolder");
    need("bankAccount", "Enter the account number");
    need("swift", "Enter the SWIFT / BIC code");
    if (d.swift && !RX.swift.test(up("swift"))) e.swift = "8 or 11 characters, e.g. DEUTDEFF500";
    need("bankCountry", "Enter the bank's country");
    if (d.iban && !RX.iban.test(up("iban"))) e.iban = "Check the IBAN, e.g. GB82WEST12345698765432";
  }
  if (step === 5) {
    need("declPlace", "Enter the place of signing"); need("signatory", "Name the authorised signatory");
    if (!d.agreed) e.agreed = "Confirm the declaration to submit";
  }
  return e;
}
function stepErrors(step, d) {
  if (d.vendorType === "international") return intlStepErrors(step, d);
  const e = {};
  const need = (k, msg) => { if (!String(d[k] || "").trim()) e[k] = msg || "Required"; };
  if (step === 1) {
    need("firmName", "Enter the firm's registered name");
    need("address", "Enter the full address");
    need("city"); need("state"); need("pincode");
    if (d.pincode && !/^[0-9]{6}$/.test(d.pincode)) e.pincode = "6 digits";
  }
  if (step === 2) {
    need("email"); if (d.email && !RX.email.test(d.email)) e.email = "Check the email address";
    need("mobile"); if (d.mobile && !RX.mobile.test(d.mobile.replace(/\D/g, "").slice(-10))) e.mobile = "10-digit mobile number";
    if (!d.people[0] || !d.people[0].name.trim()) e.person0 = "Add at least one contact person";
    need("items", "List what you supply");
  }
  if (step === 3) {
    need("panNo"); if (d.panNo && !RX.pan.test(d.panNo.toUpperCase())) e.panNo = "Format ABCDE1234F";
    if (d.gstNo && !RX.gst.test(d.gstNo.toUpperCase())) e.gstNo = "15 characters, e.g. 27DFYPM7221H1ZV";
    if (d.gstNo && d.panNo && RX.gst.test(d.gstNo.toUpperCase()) && RX.pan.test(d.panNo.toUpperCase())
      && d.gstNo.toUpperCase().slice(2, 12) !== d.panNo.toUpperCase()) e.gstNo = "This GSTIN does not carry the PAN above";
    if (d.isForeign === "yes" && !d.peStatus) e.peStatus = "Confirm PE status";
    need("size", "Pick one");
  }
  if (step === 4) {
    need("bankName"); need("accountHolder");
    need("bankAccount"); if (d.bankAccount && !/^[0-9]{6,20}$/.test(d.bankAccount.replace(/\s/g, ""))) e.bankAccount = "Digits only";
    need("ifsc"); if (d.ifsc && !RX.ifsc.test(d.ifsc.toUpperCase())) e.ifsc = "Format KKBK0001409";
  }
  if (step === 5) {
    need("declPlace", "Enter the place of signing"); need("signatory", "Name the authorised signatory");
    if (!d.agreed) e.agreed = "Confirm the declaration to submit";
  }
  return e;
}

/* ---------------- helpers ---------------- */
const fileToB64 = (file) => new Promise((res, rej) => {
  const r = new FileReader();
  r.onload = () => res(String(r.result).split(",")[1]);
  r.onerror = () => rej(new Error("Could not read " + file.name));
  r.readAsDataURL(file);
});
const guessType = (name, intl) => {
  const n = name.toLowerCase();
  if (intl) {
    // Most specific first: "foreign trade registration certificate" would
    // otherwise match the licence or the generic "certificate" rules.
    if (/foreign.?trade|import|export|\biec\b/.test(n)) return "Foreign Trade Registration Certificate";
    if (/contract|purchase|\bpo\b|agreement/.test(n)) return "Purchase Contract";
    if (/trc|residen/.test(n)) return "Tax residency certificate (TRC)";
    if (/(^|[^a-z])tin([^a-z]|$)|vat|tax|ein|uen|gst/.test(n)) return "TIN certificate";
    if (/bank|cheque|check|swift|iban/.test(n)) return "Bank Account Certificate";
    if (/licen[cs]e|business|incorp|coi|moa|registration/.test(n)) return "Business License";
    if (/\bpe\b|no.?pe|permanent/.test(n)) return "No PE declaration";
    if (/pan/.test(n)) return "PAN card";
    if (/iso|quality|complian|cert/.test(n)) return "Quality & Compliance Certificates";
    if (/declar|signed|form/.test(n)) return "Signed declaration";
    return "Other";
  }
  if (/gst|gstin/.test(n)) return "GST certificate";
  if (/pan/.test(n)) return "PAN card";
  if (/cheque|check|bank|passbook/.test(n)) return "Cancelled cheque";
  if (/udyam|msme/.test(n)) return "Udyam / MSME certificate";
  if (/iso|isi/.test(n)) return "ISO / ISI certificate";
  if (/incorp|registration|coi|moa/.test(n)) return "Incorporation / registration";
  if (/declar|signed|form/.test(n)) return "Signed declaration";
  return "Other";
};
const kb = (b) => (b > 1024 * 1024 ? (b / 1048576).toFixed(1) + " MB" : Math.max(1, Math.round(b / 1024)) + " KB");
const ref = (prefix) => prefix + "-" + new Date().getFullYear() + "-" + Math.random().toString(36).slice(2, 7).toUpperCase();

/* ---------------- document reading (Claude API) ---------------- */
const EXTRACT_PROMPT = `You are reading Indian vendor onboarding documents (GST certificate, PAN card, cancelled cheque, Udyam/MSME certificate, incorporation papers).
Extract every field you can actually see. Do not guess or invent values. Use null when a field is not visible.
Respond with ONLY a JSON object, no markdown fences and no commentary, with exactly these keys:
{"firmName":,"address":,"city":,"state":,"pincode":,"country":,"email":,"mobile":,"phone":,"website":,
"gstNo":,"gstDate":,"gstDealer":,"panNo":,"panDate":,"udyamNo":,"udyamDate":,"size":,
"natureBusiness":,"natureCompany":,"bankName":,"bankAccount":,"ifsc":,"accountHolder":,"branch":,"swift":,"iban":,
"certTypes":,"items":,"contactName":,"contactDesignation":,"contactPhone":}
Rules: dates as YYYY-MM-DD. gstNo/panNo/ifsc uppercase, no spaces. gstDealer is "Regular" or "Composite".
size is Micro, Small, Medium or Large (from the Udyam certificate classification).
natureCompany is one of: Proprietary, Partnership, Private Ltd., Public Ltd., Foreign company.
natureBusiness is one of: Manufacturing, Sole selling agent, Dealer, Trader, Agent, Assembler.
address is the street address only; keep city, state and pincode separate.
certTypes is a comma-separated string of quality or registration certifications the firm holds, such as ISO 9001:2015, ISI, BIS, FSSAI or Udyam/MSME. Never list GST, PAN or the cancelled cheque there; use null if there are none.`;

// Same contract for a supplier registered outside India.
const EXTRACT_PROMPT_INTL = `You are reading onboarding documents of a vendor registered OUTSIDE India (business license, bank account certificate, TIN certificate, foreign trade registration certificate, quality & compliance certificates, purchase contract).
Extract every field you can actually see. Do not guess or invent values. Use null when a field is not visible.
Respond with ONLY a JSON object, no markdown fences and no commentary, with exactly these keys:
{"firmName":,"address":,"city":,"state":,"pincode":,"country":,"email":,"mobile":,"phone":,"website":,
"vatNo":,"vatDate":,"panNo":,"natureBusiness":,"natureCompany":,
"bankName":,"bankAddress":,"bankCountry":,"bankAccount":,"accountHolder":,"swift":,"iban":,
"certTypes":,"items":,"contactName":,"contactDesignation":,"contactPhone":}
Rules: dates as YYYY-MM-DD. vatNo is the TIN, VAT, GST, EIN, UEN or other company tax registration number of the vendor's own country, uppercase, no spaces.
panNo only if an Indian PAN appears. swift (BIC, 8 or 11 characters) and iban uppercase, no spaces.
mobile and phone keep the country code, e.g. +44 20 7946 0000.
state is the state, province or region; pincode is the postal / ZIP code; country is the full country name.
bankAddress is the bank branch's address; bankCountry is the country the bank account is held in.
natureCompany is one of: Proprietary, Partnership, Private Ltd., Public Ltd., Foreign company.
natureBusiness is one of: Manufacturing, Sole selling agent, Dealer, Trader, Agent, Assembler.
address is the street address only; keep city, state, postal code and country separate.
certTypes is a comma-separated string of quality certifications the firm holds, such as ISO 9001:2015, CE or BIS. Never list the tax registration or bank documents there; use null if there are none.`;

/* Claude's vision API accepts JPEG, PNG, GIF and WebP only — not HEIC/HEIF,
   which is what iPhones produce by default. It also downscales anything past
   the model's long-edge limit before reading it.

   So every image is re-encoded to JPEG at that limit before being sent: it
   guarantees a supported format, converts HEIC on the devices that shoot it
   (Safari can decode it), and cuts the payload with no loss of detail the
   model would have kept anyway. The stored copy is always the untouched
   original — only the copy sent to the reader is normalised. */
const READ_MAX_EDGE = 1568;   // Claude vision long-edge limit; larger is downscaled anyway

function loadImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = () => rej(new Error("decode failed"));
    img.src = src;
  });
}

// Returns { media_type, data } ready for an image content block, or throws
// if this browser cannot decode the file.
async function imageForReading(doc) {
  const url = "data:" + doc.mime + ";base64," + doc.data;
  let img;
  try {
    img = await loadImage(url);
  } catch (e) {
    throw new Error(
      `${doc.name} could not be read — the browser cannot open ${doc.mime || "this file type"}. ` +
      "Upload a JPG, PNG or PDF copy, or fill the form in by hand."
    );
  }
  const scale = Math.min(1, READ_MAX_EDGE / Math.max(img.width, img.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(img.width * scale));
  canvas.height = Math.max(1, Math.round(img.height * scale));
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#fff";              // flatten transparency; scans are opaque
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  const dataUrl = canvas.toDataURL("image/jpeg", 0.85);
  return { media_type: "image/jpeg", data: dataUrl.split(",")[1] };
}

async function readDocuments(files, prompt = EXTRACT_PROMPT) {
  const content = [];
  for (const f of files.slice(0, 5)) {
    if (f.mime === "application/pdf") {
      content.push({ type: "document", source: { type: "base64", media_type: "application/pdf", data: f.data } });
    } else if (f.mime.startsWith("image/")) {
      const img = await imageForReading(f);   // throws with a readable message
      content.push({ type: "image", source: { type: "base64", ...img } });
    }
  }
  if (!content.length) throw new Error("Upload a PDF or an image to read from.");
  content.push({ type: "text", text: prompt });

  const OFFLINE = "The document reader is not running. Start it with “npm run server”, then try again.";

  let r;
  try {
    r = await fetch("/api/read-documents", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ content }),
    });
  } catch (e) {
    throw new Error(OFFLINE); // nothing listening at all
  }

  if (!r.ok) {
    let detail = "";
    try { detail = (await r.json()).error || ""; } catch (e) { /* non-JSON error body */ }
    if (detail) throw new Error(detail);
    // The proxy answers every failure it owns in JSON. A non-JSON 5xx means
    // the request never reached it — usually the server is not running.
    if (r.status >= 500) throw new Error(OFFLINE);
    throw new Error("The reader could not process these files (" + r.status + "). Try one document at a time.");
  }
  const data = await r.json();
  const text = data.text || "";
  const clean = text.replace(/```json/g, "").replace(/```/g, "").trim();
  const start = clean.indexOf("{"), end = clean.lastIndexOf("}");
  if (start < 0 || end < 0) throw new Error("Nothing readable came back. The scan may be too blurry.");
  return JSON.parse(clean.slice(start, end + 1));
}

/* ============================================================
   APP
   ============================================================ */
export default function App() {
  // Two separate pages, chosen by URL. There is deliberately no link between
  // them: a vendor with a form link cannot wander into the admin panel, and
  // procurement reaches it by its own address.
  const admin = isAdminUrl();
  const brand = BRANDS[readBrandFromUrl()];
  const [kind, setKind] = useState(readKindFromUrl);

  // Back/forward between the choice page and a form.
  useEffect(() => {
    const onPop = () => setKind(readKindFromUrl());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  const pickKind = (k) => {
    try { window.history.pushState(null, "", "/" + brand.id + "/" + k); } catch (e) { /* old browser */ }
    setKind(k);
    window.scrollTo({ top: 0 });
  };

  useEffect(() => {
    document.title = (admin ? "Procurement" : brand.name) + " — Vendor Registration";
  }, [brand.name, admin]);

  if (admin) {
    return (
      <div className="cb">
        <style>{CSS}</style>
        <Admin />
      </div>
    );
  }

  return (
    <div className="cb" style={brand.theme}>
      <style>{CSS}</style>
      <header className="cb-top">
        <div className="cb-top-in">
          <div className="cb-mark">
            <img className="cb-logo" src={brand.logoLight} alt={brand.name} />
            <span className="cb-mark-sub">Vendor registration</span>
          </div>
        </div>
      </header>
      {kind ? <VendorFlow key={kind} brand={brand} kind={kind} /> : <KindChooser brand={brand} onPick={pickKind} />}
      <div className="cb-foot cb-noprint">
        Submissions go to the procurement team and are reviewed in order by Finance, then IT.
      </div>
    </div>
  );
}

/* ============================================================
   VENDOR SIDE
   ============================================================ */
/* First page of a brand's link: is this an Indian supplier or a foreign one?
   The two forms ask for different tax and bank details. */
function KindChooser({ brand, onPick }) {
  const option = (k, title, lede, needs) => (
    <button type="button" className="cb-choice" onClick={() => onPick(k)}>
      <span className="cb-choice-t">{title}</span>
      <span className="cb-choice-l">{lede}</span>
      <span className="cb-choice-n">{needs}</span>
      <span className="cb-choice-go">Continue {I.right()}</span>
    </button>
  );
  return (
    <main className="cb-narrow">
      <h1 className="cb-h1">Register as a vendor</h1>
      <p className="cb-lede">Choose where your business is registered. The two forms ask for different tax and bank details.</p>
      <div className="cb-choices">
        {option("domestic", "Domestic vendor", "Registered in India.",
          "You will need: GST certificate, PAN card, cancelled cheque, Udyam certificate (if any).")}
        {option("international", "International vendor", "Registered outside India.",
          "You will need: business license, bank account certificate, TIN certificate, foreign trade registration, quality & compliance certificates, purchase contract.")}
      </div>
      <p className="cb-hint">Supplying {brand.name}. Not sure? Choose where your company pays its taxes.</p>
    </main>
  );
}

function VendorFlow({ brand, kind = "domestic" }) {
  const [step, setStep] = useState(0);
  const [d, setD] = useState(() => blank(kind));
  const intl = kind === "international";
  const [docs, setDocs] = useState([]);
  const [errs, setErrs] = useState({});
  const [auto, setAuto] = useState({});
  const [reading, setReading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [done, setDone] = useState(null);
  const [saving, setSaving] = useState(false);

  const set = (k, v) => { setD((p) => ({ ...p, [k]: v })); setErrs((p) => ({ ...p, [k]: undefined })); };
  const go = (n) => { setStep(n); setMsg(null); requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: "smooth" })); };

  const next = () => {
    const e = stepErrors(step, d);
    setErrs(e);
    if (Object.keys(e).length) { setMsg({ t: "bad", m: "Check the highlighted fields before continuing." }); return; }
    go(step + 1);
  };

  const addFiles = async (list) => {
    const incoming = [];
    const skipped = [];
    for (const f of Array.from(list)) {
      if (f.size > MAX_FILE_BYTES) { skipped.push(f.name + " is over 8 MB"); continue; }
      const mime = safeMime(f);
      if (!mime) { skipped.push(f.name + " is not a PDF or an image"); continue; }
      try {
        incoming.push({ id: Math.random().toString(36).slice(2), name: f.name, mime, size: f.size, type: guessType(f.name, intl), data: await fileToB64(f) });
      } catch (err) { skipped.push(err.message); }
    }
    if (incoming.length) setDocs((p) => [...p, ...incoming]);
    // Report every rejection, even when other files in the same drop were
    // accepted — otherwise a skipped file just vanishes with no explanation.
    if (skipped.length) {
      setMsg({ t: "warn", m: "Not added — " + skipped.join("; ") + ". Send PDF, JPG or PNG copies under 8 MB each." });
    } else if (incoming.length) setMsg(null);
  };

  const runRead = async () => {
    setReading(true); setMsg(null);
    try {
      const got = await readDocuments(docs, intl ? EXTRACT_PROMPT_INTL : EXTRACT_PROMPT);
      const filled = {};
      const patch = {};
      const put = (k, v) => {
        if (Array.isArray(v)) v = v.filter((x) => x != null && String(x).trim()).join(", ");
        if (v === null || v === undefined || String(v).trim() === "" || String(v).toLowerCase() === "null") return;
        patch[k] = String(v).trim(); filled[k] = true;
      };
      ["firmName", "address", "city", "state", "pincode", "country", "email", "mobile", "phone", "website",
        "gstDate", "panDate", "udyamNo", "udyamDate", "bankName", "bankAccount", "accountHolder", "branch",
        "certTypes", "items", "vatDate", "bankAddress", "bankCountry"].forEach((k) => put(k, got[k]));
      if (got.gstNo) put("gstNo", String(got.gstNo).toUpperCase().replace(/\s/g, ""));
      if (got.panNo) put("panNo", String(got.panNo).toUpperCase().replace(/\s/g, ""));
      if (got.ifsc) put("ifsc", String(got.ifsc).toUpperCase().replace(/\s/g, ""));
      for (const k of ["swift", "iban", "vatNo"]) {
        if (got[k]) put(k, String(got[k]).toUpperCase().replace(/\s/g, ""));
      }
      if (got.gstDealer && /composite/i.test(got.gstDealer)) put("gstDealer", "Composite");
      if (got.size && SIZES.includes(got.size)) put("size", got.size);
      if (got.natureCompany && NATURE_COMPANY.includes(got.natureCompany)) put("natureCompany", got.natureCompany);
      if (got.natureBusiness && NATURE_BUSINESS.includes(got.natureBusiness)) put("natureBusiness", got.natureBusiness);
      if (got.certTypes) patch.certified = "yes";

      let people = null;
      if (got.contactName) {
        people = [{ name: String(got.contactName), designation: got.contactDesignation || "", qualification: "", phone: got.contactPhone || "", place: got.city || "" }];
        filled.person0 = true;
      }
      setD((p) => ({ ...p, ...patch, ...(people ? { people } : {}), declPlace: p.declPlace || patch.city || "" }));
      setAuto((p) => ({ ...p, ...filled }));
      const n = Object.keys(filled).length;
      if (!n) setMsg({ t: "warn", m: "Nothing could be read from these files. Fill the form in by hand — it only takes a few minutes." });
      // go() clears the banner, so set it afterwards — this is the one message
      // the vendor most needs to see on the step it points at.
      else { go(1); setMsg({ t: "ok", m: n + " field" + (n === 1 ? "" : "s") + " filled from your documents. Check each one — scans misread digits sometimes." }); }
    } catch (err) {
      setMsg({ t: "bad", m: err.message });
    } finally { setReading(false); }
  };

  const submit = async () => {
    const e = stepErrors(5, d);
    setErrs(e);
    if (Object.keys(e).length) { setMsg({ t: "bad", m: "Confirm the declaration and signatory details." }); return; }
    setSaving(true);
    try {
      const reference = ref(brand.refPrefix);
      // The server writes the record and its documents in one transaction, so
      // a reference is only shown once the whole submission is on disk.
      await registry.submit({
        brand: brand.id,
        reference,
        autoFilled: Object.keys(auto),
        data: d,
        docs: docs.map((f) => ({ id: f.id, name: f.name, mime: f.mime, size: f.size, type: f.type, data: f.data })),
      });
      setDone({ reference, unstored: 0 });
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      setMsg({ t: "bad", m: err.message || "The submission did not save. Check your connection and try again." });
    } finally { setSaving(false); }
  };

  if (done) return <Submitted brand={brand} done={done} onNew={() => { setDone(null); setD(blank(kind)); setDocs([]); setAuto({}); setStep(0); }} />;

  return (
    <main className="cb-narrow">
      <div className="cb-rail" aria-hidden="true">
        {STEPS.map((s, i) => <i key={s} className={i < step ? "on" : i === step ? "now" : ""} />)}
      </div>
      <div className="cb-railcap">
        <span className="cb-eyebrow">
          {intl ? "International vendor · " : "Domestic vendor · "}Step {step + 1} of {STEPS.length} · {STEPS[step]}</span>
        {step > 0 && <button className="cb-btn ghost sm" onClick={() => go(step - 1)}>Back</button>}
      </div>

      {msg && <div className={"cb-note " + msg.t} style={{ marginBottom: 14 }} role="status">{msg.m}</div>}

      {step === 0 && <StepDocs intl={intl} docs={docs} setDocs={setDocs} addFiles={addFiles} reading={reading} runRead={runRead} skip={() => go(1)} />}
      {step === 1 && <StepCompany intl={intl} d={d} set={set} errs={errs} auto={auto} onNext={next} />}
      {step === 2 && <StepContacts intl={intl} brand={brand} d={d} setD={setD} set={set} errs={errs} auto={auto} onNext={next} />}
      {step === 3 && (intl
        ? <StepTaxIntl d={d} set={set} errs={errs} auto={auto} onNext={next} />
        : <StepTax d={d} set={set} errs={errs} auto={auto} onNext={next} />)}
      {step === 4 && (intl
        ? <StepBankIntl d={d} set={set} errs={errs} auto={auto} onNext={next} />
        : <StepBank d={d} set={set} errs={errs} auto={auto} onNext={next} />)}
      {step === 5 && <StepReview intl={intl} brand={brand} d={d} set={set} errs={errs} docs={docs} onEdit={go} onSubmit={submit} saving={saving} />}
    </main>
  );
}

/* ---------- field primitives ---------- */
function F({ label, k, d, set, errs, auto, type = "text", code, required, placeholder, hint, span, children }) {
  const err = errs[k];
  return (
    <div className={"cb-f" + (span ? " cb-span" : "")}>
      <label htmlFor={"f_" + k}>
        {label}{required && <span className="req">*</span>}
        {auto && auto[k] && <span className="cb-auto">from document</span>}
      </label>
      {children || (
        <input id={"f_" + k} type={type} className={code ? "code" : ""} value={d[k] || ""} placeholder={placeholder}
          aria-invalid={err ? "true" : undefined}
          onChange={(e) => set(k, code ? e.target.value.toUpperCase() : e.target.value)} />
      )}
      {err && <span className="err">{err}</span>}
      {!err && hint && <span className="cb-hint">{hint}</span>}
    </div>
  );
}
function Chips({ label, options, value, onPick, err, required }) {
  return (
    <div className="cb-f cb-span">
      <label>{label}{required && <span className="req">*</span>}</label>
      <div className="cb-chips">
        {options.map((o) => (
          <button key={o} type="button" aria-pressed={value === o} onClick={() => onPick(o)}>{o}</button>
        ))}
      </div>
      {err && <span className="err">{err}</span>}
    </div>
  );
}

/* ---------- step 0: documents ---------- */
// International: which of the six required documents have no file of that
// type yet (shown on the review step and in the admin record).
const missingIntlDocs = (docs) => DOCS_REQUIRED_INTL.filter((t) => !docs.some((f) => f.type === t));

function StepDocs({ intl, docs, setDocs, addFiles, reading, runRead, skip }) {
  const [over, setOver] = useState(false);
  const input = useRef(null);
  const types = intl ? DOC_TYPES_INTL : DOC_TYPES;
  return (
    <>
      <h1 className="cb-h1">Start with your documents</h1>
      {intl
        ? <p className="cb-lede">Upload your business license, bank account certificate, TIN certificate, foreign trade
            registration certificate, quality &amp; compliance certificates and purchase contract. If you have a PE in India,
            add your PAN card too. We read them and fill the registration form for you — you review and correct anything
            that came out wrong.</p>
        : <p className="cb-lede">Upload your GST certificate, PAN card, cancelled cheque and Udyam certificate. We read them and
            fill the registration form for you — you review and correct anything that came out wrong.</p>}

      <div className={"cb-drop" + (over ? " over" : "")}
        onDragOver={(e) => { e.preventDefault(); setOver(true); }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => { e.preventDefault(); setOver(false); addFiles(e.dataTransfer.files); }}>
        <div style={{ color: "var(--accent)" }}>{I.up()}</div>
        <h3>Add your documents</h3>
        <p>PDF, JPG or PNG · up to 8 MB each · photos of the originals are fine</p>
        <button className="cb-btn" onClick={() => input.current && input.current.click()}>Choose files</button>
        <input ref={input} type="file" multiple accept="image/*,application/pdf" style={{ display: "none" }}
          onChange={(e) => { addFiles(e.target.files); e.target.value = ""; }} />
      </div>

      {docs.length > 0 && (
        <div className="cb-filelist">
          {docs.map((f) => (
            <div className="cb-file" key={f.id}>
              <div className="ico">{I.file()}</div>
              <div className="meta">
                <div className="nm">{f.name}</div>
                <div className="sub">{kb(f.size)}</div>
              </div>
              <select value={f.type} aria-label={"Document type for " + f.name}
                onChange={(e) => setDocs((p) => p.map((x) => (x.id === f.id ? { ...x, type: e.target.value } : x)))}>
                {(types.includes(f.type) ? types : [f.type, ...types]).map((t) => <option key={t}>{t}</option>)}
              </select>
              <button className="cb-x" aria-label={"Remove " + f.name}
                onClick={() => setDocs((p) => p.filter((x) => x.id !== f.id))}>{I.x()}</button>
            </div>
          ))}
        </div>
      )}

      {reading && (
        <div className="cb-reading">
          <div className="cb-pulse"><i /><i /><i /><i /></div>
          <div><b>Reading your documents</b><div style={{ fontSize: 12.5, color: "#C9BCC5" }}>Usually 10–20 seconds</div></div>
        </div>
      )}

      <div className="cb-navbar">
        <button className="cb-btn grow" disabled={!docs.length || reading} onClick={runRead}>
          {reading ? "Reading…" : "Read documents and fill the form"}
        </button>
      </div>
      <div className="cb-navbar">
        <button className="cb-btn ghost grow" onClick={skip}>Fill the form myself</button>
      </div>
      {docs.length > 5 && <p className="cb-hint" style={{ marginTop: 10 }}>Only the first five files are read. The rest are still filed with your submission.</p>}
    </>
  );
}

/* ---------- step 1: company ---------- */
function StepCompany({ intl, d, set, errs, auto, onNext }) {
  return (
    <>
      <h1 className="cb-h1">Company details</h1>
      <p className="cb-lede">{intl
        ? "The registered name and address, exactly as they appear on your certificate of incorporation."
        : "The registered name and address, exactly as they appear on your GST certificate."}</p>
      <div className="cb-card">
        <div className="cb-grid two">
          <F span label="Name of the firm" k="firmName" d={d} set={set} errs={errs} auto={auto} required placeholder="A Star M Designs" />
          <div className="cb-f cb-span">
            <label htmlFor="f_address">Registered address<span className="req">*</span>{auto.address && <span className="cb-auto">from document</span>}</label>
            <textarea id="f_address" value={d.address} aria-invalid={errs.address ? "true" : undefined}
              onChange={(e) => set("address", e.target.value)} placeholder="Flat / building, street, area" />
            {errs.address && <span className="err">{errs.address}</span>}
          </div>
          <F label="City" k="city" d={d} set={set} errs={errs} auto={auto} required />
          {intl ? (<>
            <F label="State / province" k="state" d={d} set={set} errs={errs} auto={auto} />
            <F label="Postal / ZIP code" k="pincode" d={d} set={set} errs={errs} auto={auto} />
            <F label="Country" k="country" d={d} set={set} errs={errs} auto={auto} required placeholder="United Kingdom" />
          </>) : (<>
            <F label="State" k="state" d={d} set={set} errs={errs} auto={auto} required />
            <F label="PIN code" k="pincode" d={d} set={set} errs={errs} auto={auto} required placeholder="400063" />
            <F label="Country" k="country" d={d} set={set} errs={errs} auto={auto} />
          </>)}
          <F span label="Website" k="website" d={d} set={set} errs={errs} auto={auto} placeholder="Optional" />
        </div>
      </div>
      <div className="cb-navbar"><button className="cb-btn wide" onClick={onNext}>Continue</button></div>
    </>
  );
}

/* ---------- step 2: contacts & business ---------- */
function StepContacts({ intl, brand, d, setD, set, errs, auto, onNext }) {
  const setP = (i, k, v) => setD((p) => ({ ...p, people: p.people.map((x, j) => (j === i ? { ...x, [k]: v } : x)) }));
  return (
    <>
      <h1 className="cb-h1">Contacts and business</h1>
      <p className="cb-lede">Who we reach, and what you supply.</p>

      <div className="cb-card">
        <div className="cb-card-h"><span className="cb-eyebrow">Reach the firm</span></div>
        <div className="cb-grid two">
          <F label="Email" k="email" d={d} set={set} errs={errs} auto={auto} type="email" required />
          {intl ? (<>
            <F label="Mobile (with country code)" k="mobile" d={d} set={set} errs={errs} auto={auto} required
              placeholder="+44 7700 900123" />
            <F label="Telephone (office)" k="phone" d={d} set={set} errs={errs} auto={auto}
              placeholder="+44 20 7946 0000" hint="Country code, STD / area code, then the number." />
            <F label="Fax (office)" k="fax" d={d} set={set} errs={errs} auto={auto} placeholder="+44 20 7946 0001" />
          </>) : (<>
            <F label="Mobile" k="mobile" d={d} set={set} errs={errs} auto={auto} required placeholder="9021679684" />
            <F label="Telephone (office)" k="phone" d={d} set={set} errs={errs} auto={auto} />
            <F label="Fax" k="fax" d={d} set={set} errs={errs} auto={auto} />
          </>)}
        </div>
      </div>

      <div className="cb-card">
        <div className="cb-card-h">
          <span className="cb-eyebrow">People to contact</span>
          <button className="cb-btn ghost sm" style={{ marginLeft: "auto" }}
            onClick={() => setD((p) => ({ ...p, people: [...p.people, { name: "", designation: "", qualification: "", phone: "", place: "" }] }))}>
            Add person
          </button>
        </div>
        {d.people.map((p, i) => (
          <div key={i} style={{ paddingTop: i ? 14 : 0, marginTop: i ? 14 : 0, borderTop: i ? "1px solid var(--line-2)" : "none" }}>
            <div className="cb-grid two">
              <div className="cb-f"><label>Name{i === 0 && <span className="req">*</span>}{i === 0 && auto.person0 && <span className="cb-auto">from document</span>}</label>
                <input value={p.name} aria-invalid={i === 0 && errs.person0 ? "true" : undefined} onChange={(e) => setP(i, "name", e.target.value)} /></div>
              <div className="cb-f"><label>Designation</label><input value={p.designation} onChange={(e) => setP(i, "designation", e.target.value)} /></div>
              <div className="cb-f"><label>Qualification</label><input value={p.qualification} onChange={(e) => setP(i, "qualification", e.target.value)} /></div>
              <div className="cb-f"><label>Contact number</label><input value={p.phone} onChange={(e) => setP(i, "phone", e.target.value)} /></div>
              <div className="cb-f"><label>Place</label><input value={p.place} onChange={(e) => setP(i, "place", e.target.value)} /></div>
              {i > 0 && (
                <div className="cb-f" style={{ justifyContent: "flex-end" }}>
                  <button className="cb-btn ghost sm" onClick={() => setD((q) => ({ ...q, people: q.people.filter((_, j) => j !== i) }))}>Remove</button>
                </div>
              )}
            </div>
          </div>
        ))}
        {errs.person0 && <div className="cb-f"><span className="err">{errs.person0}</span></div>}
      </div>

      <div className="cb-card">
        <div className="cb-grid">
          <Chips label="Nature of business" options={NATURE_BUSINESS} value={d.natureBusiness} err={errs.natureBusiness} onPick={(v) => set("natureBusiness", v)} />
          <Chips label="Nature of company" options={NATURE_COMPANY} value={d.natureCompany} err={errs.natureCompany} onPick={(v) => set("natureCompany", v)} />
          <div className="cb-f cb-span">
            <label htmlFor="f_items">Items, products or services supplied<span className="req">*</span>{auto.items && <span className="cb-auto">from document</span>}</label>
            <textarea id="f_items" value={d.items} aria-invalid={errs.items ? "true" : undefined} onChange={(e) => set("items", e.target.value)}
              placeholder="One per line, e.g.&#10;Civil / electrical fit-out&#10;Furniture and signage" />
            {errs.items && <span className="err">{errs.items}</span>}
          </div>
          <div className="cb-f cb-span">
            <label htmlFor="f_reason">Reason for new vendor creation</label>
            <textarea id="f_reason" value={d.reason} onChange={(e) => set("reason", e.target.value)}
              placeholder="Which work or category this registration is for" />
            <span className="cb-hint">Optional — procurement fills this in if you leave it blank.</span>
          </div>
          <F span label={"Relation with any " + brand.name + " employee or director"} k="relation" d={d} set={set} errs={errs} auto={auto}
            placeholder="Write 'None' if there is no relation" hint="Declare any relationship — it does not disqualify you, but it must be on record." />
        </div>
      </div>

      <div className="cb-navbar"><button className="cb-btn wide" onClick={onNext}>Continue</button></div>
    </>
  );
}

/* ---------- step 3: tax & compliance ---------- */
function StepTax({ d, set, errs, auto, onNext }) {
  return (
    <>
      <h1 className="cb-h1">Tax and compliance</h1>
      <p className="cb-lede">Check every identifier against the original document — one wrong character blocks payment later.</p>

      <div className="cb-card">
        <div className="cb-card-h"><span className="cb-eyebrow">Registration</span></div>
        <div className="cb-grid two">
          <F label="PAN" k="panNo" d={d} set={set} errs={errs} auto={auto} code required placeholder="DFYPM7221H" />
          <F label="PAN issue date" k="panDate" d={d} set={set} errs={errs} auto={auto} type="date" />
          <F label="GSTIN" k="gstNo" d={d} set={set} errs={errs} auto={auto} code placeholder="27DFYPM7221H1ZV" />
          <F label="GST registration date" k="gstDate" d={d} set={set} errs={errs} auto={auto} type="date" />
          <div className="cb-f">
            <label htmlFor="f_gstDealer">Type of GST dealer</label>
            <select id="f_gstDealer" value={d.gstDealer} onChange={(e) => set("gstDealer", e.target.value)}>
              <option>Regular</option><option>Composite</option>
            </select>
          </div>
          <div className="cb-f">
            <label htmlFor="f_isForeign">Foreign entity?</label>
            <select id="f_isForeign" value={d.isForeign} onChange={(e) => set("isForeign", e.target.value)}>
              <option value="no">No</option><option value="yes">Yes</option>
            </select>
          </div>
          {d.isForeign === "yes" && (
            <div className="cb-f cb-span">
              <label htmlFor="f_peStatus">Permanent establishment (PE) status<span className="req">*</span></label>
              <select id="f_peStatus" value={d.peStatus} aria-invalid={errs.peStatus ? "true" : undefined} onChange={(e) => set("peStatus", e.target.value)}>
                <option value="">Select</option><option value="yes">Yes — PE in India</option><option value="no">No PE in India</option>
              </select>
              {errs.peStatus ? <span className="err">{errs.peStatus}</span>
                : d.peStatus === "yes" ? <span className="cb-hint">PAN is mandatory when PE status is yes.</span> : null}
            </div>
          )}
        </div>
      </div>

      <div className="cb-card">
        <div className="cb-card-h"><span className="cb-eyebrow">Enterprise size</span></div>
        <div className="cb-grid two">
          <Chips required label="Size of the company" options={SIZES} value={d.size} err={errs.size} onPick={(v) => set("size", v)} />
          <F label="Udyam / enterprise registration no." k="udyamNo" d={d} set={set} errs={errs} auto={auto} code />
          <F label="Registration date" k="udyamDate" d={d} set={set} errs={errs} auto={auto} type="date" />
        </div>
      </div>

      <CertBlock d={d} set={set} errs={errs} auto={auto} />
      <ExemptionBlock d={d} set={set} errs={errs} auto={auto} />

      <div className="cb-navbar"><button className="cb-btn wide" onClick={onNext}>Continue</button></div>
    </>
  );
}

// ISO / ISI / MSME certification — same questions on both forms.
function CertBlock({ d, set, errs, auto, intl }) {
  return (
    <div className="cb-card">
      <div className="cb-card-h"><span className="cb-eyebrow">Certification</span></div>
      <div className="cb-grid two">
        <div className="cb-f">
          <label htmlFor="f_certified">Registered with ISO / ISI / MSME / other?</label>
          <select id="f_certified" value={d.certified} onChange={(e) => set("certified", e.target.value)}>
            <option value="yes">Yes</option><option value="no">No</option>
          </select>
        </div>
        {d.certified === "yes" ? (
          <F label="Which certifications" k="certTypes" d={d} set={set} errs={errs} auto={auto}
            placeholder={intl ? "ISO 9001:2015, CE" : "ISO 9001:2015, Udyam"} hint="Attach the certificate on the documents step." />
        ) : (
          <>
            <div className="cb-f">
              <label htmlFor="f_certInProcess">In process of acquiring?</label>
              <select id="f_certInProcess" value={d.certInProcess} onChange={(e) => set("certInProcess", e.target.value)}>
                <option value="no">No</option><option value="yes">Yes</option>
              </select>
            </div>
            {d.certInProcess === "yes" && <F label="Expected date of receipt" k="certExpected" d={d} set={set} errs={errs} auto={auto} type="date" />}
          </>
        )}
      </div>
    </div>
  );
}

// Indian income tax exemption — optional on both forms.
function ExemptionBlock({ d, set, errs, auto }) {
  return (
    <details className="cb-card" style={{ padding: 0 }}>
      <summary style={{ padding: "16px 18px", cursor: "pointer", fontWeight: 600, fontSize: 14 }}>
        Income tax exemption — only if you hold one
      </summary>
      <div style={{ padding: "0 18px 18px" }}>
        <div className="cb-grid two">
          <F label="Section of the IT Act" k="itSection" d={d} set={set} errs={errs} auto={auto} placeholder="e.g. 197" />
          <F label="Exemption certificate no." k="itExNo" d={d} set={set} errs={errs} auto={auto} code />
          <F label="Rate (%)" k="itExRate" d={d} set={set} errs={errs} auto={auto} />
          <div />
          <F label="Valid from" k="itExFrom" d={d} set={set} errs={errs} auto={auto} type="date" />
          <F label="Valid to" k="itExTo" d={d} set={set} errs={errs} auto={auto} type="date" />
        </div>
      </div>
    </details>
  );
}

/* ---------- step 3, international: tax ----------
   From the BB international form: the vendor must confirm PE status; PAN is
   mandatory only with a PE in India; VAT number in place of GSTIN. */
function StepTaxIntl({ d, set, errs, auto, onNext }) {
  return (
    <>
      <h1 className="cb-h1">Tax and compliance</h1>
      <p className="cb-lede">Check every identifier against the original document — one wrong character blocks payment later.</p>

      <div className="cb-card">
        <div className="cb-card-h"><span className="cb-eyebrow">Permanent establishment</span></div>
        <div className="cb-grid">
          <div className="cb-f">
            <label htmlFor="f_peStatus">Do you have a permanent establishment (PE) in India?<span className="req">*</span></label>
            <select id="f_peStatus" value={d.peStatus} aria-invalid={errs.peStatus ? "true" : undefined}
              onChange={(e) => set("peStatus", e.target.value)}>
              <option value="">Select</option>
              <option value="no">No PE in India</option>
              <option value="yes">Yes — PE in India</option>
            </select>
            {errs.peStatus ? <span className="err">{errs.peStatus}</span>
              : <span className="cb-hint">Foreign vendors must confirm their PE status. If it is yes, PAN is mandatory.</span>}
          </div>
        </div>
      </div>

      <div className="cb-card">
        <div className="cb-card-h"><span className="cb-eyebrow">Registration</span></div>
        <div className="cb-grid two">
          <F label="VAT / TIN number" k="vatNo" d={d} set={set} errs={errs} auto={auto} code required
            placeholder="GB123456789" hint="As on your TIN certificate: the VAT, TIN, EIN or other tax number in your own country." />
          <F label="VAT registration date" k="vatDate" d={d} set={set} errs={errs} auto={auto} type="date" />
          <F label="PAN" k="panNo" d={d} set={set} errs={errs} auto={auto} code required={d.peStatus === "yes"}
            placeholder="ABCDE1234F" hint={d.peStatus === "yes" ? "Required — you have a PE in India." : "Only if you hold an Indian PAN."} />
          <F label="PAN issue date" k="panDate" d={d} set={set} errs={errs} auto={auto} type="date" />
          <div className="cb-f">
            <label htmlFor="f_gstDealer">Type of GST dealer (India)</label>
            <select id="f_gstDealer" value={d.gstDealer} onChange={(e) => set("gstDealer", e.target.value)}>
              <option value="">Not registered in India</option><option>Regular</option><option>Composite</option>
            </select>
          </div>
        </div>
      </div>

      <div className="cb-card">
        <div className="cb-card-h"><span className="cb-eyebrow">Enterprise size</span></div>
        <div className="cb-grid two">
          <Chips label="Size of the company" options={SIZES} value={d.size} err={errs.size} onPick={(v) => set("size", v)} />
          <F label="Enterprise registration no." k="udyamNo" d={d} set={set} errs={errs} auto={auto} code />
          <F label="Registration date" k="udyamDate" d={d} set={set} errs={errs} auto={auto} type="date" />
        </div>
      </div>

      <CertBlock intl d={d} set={set} errs={errs} auto={auto} />
      <ExemptionBlock d={d} set={set} errs={errs} auto={auto} />

      <div className="cb-navbar"><button className="cb-btn wide" onClick={onNext}>Continue</button></div>
    </>
  );
}

/* ---------- step 4, international: bank ----------
   Name and address of the banker, SWIFT and IBAN in place of IFSC. */
function StepBankIntl({ d, set, errs, auto, onNext }) {
  return (
    <>
      <h1 className="cb-h1">Bank details</h1>
      <p className="cb-lede">Payments go to this account by international transfer. Match the bank letter or cancelled cheque you attach.</p>
      <div className="cb-card">
        <div className="cb-grid two">
          <F label="Bank name" k="bankName" d={d} set={set} errs={errs} auto={auto} required placeholder="Barclays Bank UK PLC" span />
          <div className="cb-f cb-span">
            <label htmlFor="f_bankAddress">Bank address<span className="req">*</span>{auto.bankAddress && <span className="cb-auto">from document</span>}</label>
            <textarea id="f_bankAddress" value={d.bankAddress} aria-invalid={errs.bankAddress ? "true" : undefined}
              onChange={(e) => set("bankAddress", e.target.value)} placeholder="Branch address, city, postal code" />
            {errs.bankAddress && <span className="err">{errs.bankAddress}</span>}
          </div>
          <F label="Account holder's name" k="accountHolder" d={d} set={set} errs={errs} auto={auto} required span />
          <F label="Bank account number" k="bankAccount" d={d} set={set} errs={errs} auto={auto} code required />
          <F label="SWIFT / BIC code" k="swift" d={d} set={set} errs={errs} auto={auto} code required placeholder="BUKBGB22" />
          <F label="IBAN" k="iban" d={d} set={set} errs={errs} auto={auto} code placeholder="GB82WEST12345698765432"
            hint="If your country uses IBAN (Europe, Middle East and others)." />
          <F label="Country of the bank" k="bankCountry" d={d} set={set} errs={errs} auto={auto} required placeholder="United Kingdom" />
        </div>
      </div>
      {d.accountHolder && d.firmName && d.accountHolder.trim().toLowerCase() !== d.firmName.trim().toLowerCase() && (
        <div className="cb-note warn" style={{ marginBottom: 14 }}>
          The account holder’s name does not match the firm name. That is fine if the account is genuinely in another
          name — accounts payable will ask about it, so make sure the bank letter is attached.
        </div>
      )}
      <div className="cb-note info" style={{ marginBottom: 14 }}>
        A Bank Account Certificate from your bank is required to verify the account number, SWIFT and IBAN. Add it on the
        documents step if you have not already.
      </div>
      <div className="cb-navbar"><button className="cb-btn wide" onClick={onNext}>Continue</button></div>
    </>
  );
}

/* ---------- step 4: bank ---------- */
function StepBank({ d, set, errs, auto, onNext }) {
  return (
    <>
      <h1 className="cb-h1">Bank details</h1>
      <p className="cb-lede">Payments go to this account. The name here must match the account on your cancelled cheque.</p>
      <div className="cb-card">
        <div className="cb-grid two">
          <F label="Bank name" k="bankName" d={d} set={set} errs={errs} auto={auto} required placeholder="Kotak Mahindra Bank" />
          <F label="Branch" k="branch" d={d} set={set} errs={errs} auto={auto} />
          <F label="Account holder's name" k="accountHolder" d={d} set={set} errs={errs} auto={auto} required span />
          <F label="Account number" k="bankAccount" d={d} set={set} errs={errs} auto={auto} code required />
          <F label="IFSC code" k="ifsc" d={d} set={set} errs={errs} auto={auto} code required placeholder="KKBK0001409" />
          {d.isForeign === "yes" && (<>
            <F label="SWIFT code" k="swift" d={d} set={set} errs={errs} auto={auto} code />
            <F label="IBAN" k="iban" d={d} set={set} errs={errs} auto={auto} code />
          </>)}
        </div>
      </div>
      {d.accountHolder && d.firmName && d.accountHolder.trim().toLowerCase() !== d.firmName.trim().toLowerCase() && (
        <div className="cb-note warn" style={{ marginBottom: 14 }}>
          The account holder’s name does not match the firm name. That is fine if the account is genuinely in another
          name — accounts payable will ask about it, so make sure the cheque copy is attached.
        </div>
      )}
      <div className="cb-note info" style={{ marginBottom: 14 }}>
        A cancelled cheque or bank passbook copy is required. Add it on the documents step if you have not already.
      </div>
      <div className="cb-navbar"><button className="cb-btn wide" onClick={onNext}>Continue</button></div>
    </>
  );
}

/* ---------- step 5: review ---------- */
function Row({ k, v }) {
  return <div className="cb-row"><dt>{k}</dt><dd className={v ? "" : "empty"}>{v || "Not given"}</dd></div>;
}
function StepReview({ intl, brand, d, set, errs, docs, onEdit, onSubmit, saving }) {
  return (
    <>
      <h1 className="cb-h1">Review and submit</h1>
      <p className="cb-lede">Everything below goes to the {brand.name} procurement team exactly as it reads.</p>

      <Section title="Company" onEdit={() => onEdit(1)}>
        <Row k="Firm" v={d.firmName} /><Row k="Address" v={[d.address, d.city, d.state, d.pincode, d.country].filter(Boolean).join(", ")} />
        <Row k="Email" v={d.email} /><Row k="Mobile" v={d.mobile} /><Row k="Telephone" v={d.phone} />
      </Section>

      <Section title="Business" onEdit={() => onEdit(2)}>
        <Row k="Contact person" v={d.people.filter((p) => p.name).map((p) => p.name + (p.designation ? " · " + p.designation : "")).join(" / ")} />
        <Row k="Nature of business" v={d.natureBusiness} /><Row k="Nature of company" v={d.natureCompany} />
        <Row k="Supplies" v={d.items} /><Row k="Reason for registration" v={d.reason} /><Row k={"Relation with " + brand.name + " staff"} v={d.relation} />
      </Section>

      {intl ? (
        <Section title="Tax" onEdit={() => onEdit(3)}>
          <Row k="PE in India" v={d.peStatus === "yes" ? "Yes" : d.peStatus === "no" ? "No" : ""} />
          <Row k="VAT / TIN" v={d.vatNo} /><Row k="PAN" v={d.panNo} />
          <Row k="GST dealer type" v={d.gstDealer || "Not registered in India"} />
          <Row k="Size" v={d.size} /><Row k="Enterprise reg. no." v={d.udyamNo} />
          <Row k="Certifications" v={d.certified === "yes" ? d.certTypes || "Yes" : d.certInProcess === "yes" ? "In process, expected " + (d.certExpected || "—") : "None"} />
        </Section>
      ) : (
        <Section title="Tax" onEdit={() => onEdit(3)}>
          <Row k="PAN" v={d.panNo} /><Row k="GSTIN" v={d.gstNo} /><Row k="GST dealer type" v={d.gstDealer} />
          <Row k="Size" v={d.size} /><Row k="Udyam no." v={d.udyamNo} />
          <Row k="Certifications" v={d.certified === "yes" ? d.certTypes || "Yes" : d.certInProcess === "yes" ? "In process, expected " + (d.certExpected || "—") : "None"} />
        </Section>
      )}

      {intl ? (
        <Section title="Bank" onEdit={() => onEdit(4)}>
          <Row k="Bank" v={d.bankName} /><Row k="Bank address" v={d.bankAddress} />
          <Row k="Account holder" v={d.accountHolder} /><Row k="Account number" v={d.bankAccount} />
          <Row k="SWIFT / BIC" v={d.swift} /><Row k="IBAN" v={d.iban} /><Row k="Bank country" v={d.bankCountry} />
        </Section>
      ) : (
        <Section title="Bank" onEdit={() => onEdit(4)}>
          <Row k="Bank" v={[d.bankName, d.branch].filter(Boolean).join(", ")} /><Row k="Account holder" v={d.accountHolder} />
          <Row k="Account number" v={d.bankAccount} /><Row k="IFSC" v={d.ifsc} />
        </Section>
      )}

      <Section title={"Documents (" + docs.length + ")"} onEdit={() => onEdit(0)}>
        {docs.length ? docs.map((f) => <Row key={f.id} k={f.type} v={f.name + " · " + kb(f.size)} />)
          : !intl && <div className="cb-note warn" style={{ marginTop: 10 }}>No documents attached. Registration is usually rejected without a GST certificate, PAN and cancelled cheque.</div>}
        {intl && missingIntlDocs(docs).length > 0 && (
          <div className="cb-note warn" style={{ marginTop: 10, display: "block" }}>
            <b>Still needed:</b> {missingIntlDocs(docs).join(", ")}. Registration is usually held until procurement has all
            six. You can still submit and send the rest later.
          </div>
        )}
      </Section>

      <div className="cb-card">
        <div className="cb-card-h"><span className="cb-eyebrow">Declaration</span></div>
        <p style={{ fontSize: 13.5, color: "var(--ink-2)", marginTop: 0 }}>
          The above information is true in all respects and we undertake to inform {brand.name} of any
          change in these particulars regarding our business from time to time.
        </p>
        <div className="cb-grid two">
          <F label="Authorised signatory" k="signatory" d={d} set={set} errs={errs} required />
          <F label="Place" k="declPlace" d={d} set={set} errs={errs} required />
          <F label="Date" k="declDate" d={d} set={set} errs={errs} type="date" />
        </div>
        <label style={{ display: "flex", gap: 10, alignItems: "flex-start", marginTop: 14, fontSize: 14, cursor: "pointer" }}>
          <input type="checkbox" checked={d.agreed} onChange={(e) => set("agreed", e.target.checked)} style={{ width: 18, height: 18, marginTop: 2, flex: "none" }} />
          <span>I am authorised to sign for this firm and confirm the declaration above.</span>
        </label>
        {errs.agreed && <span className="err" style={{ fontSize: 12, color: "var(--red)" }}>{errs.agreed}</span>}
      </div>

      <div className="cb-navbar">
        <button className="cb-btn wide" onClick={onSubmit} disabled={saving}>{saving ? "Submitting…" : "Submit registration"}</button>
      </div>
    </>
  );
}
function Section({ title, onEdit, children }) {
  return (
    <div className="cb-card">
      <div className="cb-card-h">
        <span className="cb-eyebrow">{title}</span>
        <button className="cb-btn ghost sm" style={{ marginLeft: "auto" }} onClick={onEdit}>Edit</button>
      </div>
      <dl className="cb-rows" style={{ margin: 0 }}>{children}</dl>
    </div>
  );
}

function Submitted({ brand, done, onNew }) {
  return (
    <main className="cb-narrow" style={{ textAlign: "center", paddingTop: 52 }}>
      <img className="cb-logo-dark" src={brand.logoDark} alt={brand.name} style={{ margin: "0 auto 22px" }} />
      <div style={{ width: 56, height: 56, borderRadius: 999, background: "var(--green-tint)", color: "var(--green)", display: "grid", placeItems: "center", margin: "0 auto 18px" }}>{I.check()}</div>
      <h1 className="cb-h1">Registration submitted</h1>
      <p className="cb-lede">Procurement reviews new vendors within three working days. Quote this reference in any follow-up.</p>
      <div className="cb-card" style={{ display: "inline-block", padding: "16px 26px" }}>
        <div className="cb-eyebrow">Reference</div>
        <div className="cb-mono" style={{ fontSize: 22, fontWeight: 600, marginTop: 4 }}>{done.reference}</div>
      </div>
      {done.unstored > 0 && (
        <div className="cb-note warn" style={{ textAlign: "left", marginTop: 14 }}>
          {done.unstored} file{done.unstored === 1 ? " was" : "s were"} too large to file with this record. Email {done.unstored === 1 ? "it" : "them"} to procurement with the reference above.
        </div>
      )}
      <div style={{ marginTop: 20 }}><button className="cb-btn ghost" onClick={onNew}>Register another vendor</button></div>
    </main>
  );
}

/* ============================================================
   ADMIN SIDE
   ============================================================ */

/* Forgot password, on the sign-in page. "forgot" asks for a username or email
   and mails a one-time link; "reset" is where that link lands
   (/admin?reset=<token>) and sets the new password. */
function PasswordHelp({ mode, token, onBack }) {
  const [identifier, setIdentifier] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [bad, setBad] = useState(null);
  const [sent, setSent] = useState(null);
  // reset mode: null while checking the link, then { name } or { dead: message }
  const [link, setLink] = useState(null);

  useEffect(() => {
    if (mode !== "reset") return;
    registry.checkReset(token)
      .then((r) => setLink({ name: r.name || r.username }))
      .catch((e) => setLink({ dead: e.message || "This reset link has expired or was already used." }));
  }, [mode, token]);

  const requestLink = async () => {
    if (busy) return;
    if (!identifier.trim()) { setBad("Enter your username or email address."); return; }
    setBusy(true);
    try { setSent((await registry.forgotPassword(identifier.trim())).message); setBad(null); }
    catch (e) { setBad(e.message); }
    finally { setBusy(false); }
  };

  const setNewPassword = async () => {
    if (busy) return;
    if (pw.length < 8) { setBad("Password must be at least 8 characters."); return; }
    if (pw !== pw2) { setBad("The two passwords do not match."); return; }
    setBusy(true);
    try {
      const r = await registry.resetWithLink(token, pw);
      onBack("Password changed for " + r.username + ". Sign in with your new password.");
    } catch (e) { setBad(e.message); setBusy(false); }
  };

  const shell = (title, lede, body) => (
    <main className="cb-narrow" style={{ maxWidth: 420, paddingTop: 52 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 18, marginBottom: 18, flexWrap: "wrap" }}>
        {BRAND_IDS.map((id) => (
          <img key={id} src={BRANDS[id].logoDark} alt={BRANDS[id].name} style={{ height: 34, width: "auto" }} />
        ))}
      </div>
      <div style={{ color: "var(--accent)" }}>{I.lock()}</div>
      <h1 className="cb-h1" style={{ marginTop: 10 }}>{title}</h1>
      <p className="cb-lede">{lede}</p>
      <div className="cb-card">
        {body}
        <button type="button" className="cb-textlink" style={{ marginTop: 12 }} onClick={() => onBack()}>
          Back to sign in</button>
      </div>
    </main>
  );

  if (mode === "forgot") return shell("Forgot password",
    "Enter your username or the email address on your account. We will email you a link to choose a new password.",
    sent ? <div className="cb-note ok" role="status">{sent}</div> : (
      <>
        <div className="cb-f">
          <label htmlFor="fid">Username or email</label>
          <input id="fid" autoComplete="username" value={identifier} aria-invalid={bad ? "true" : undefined}
            onChange={(e) => { setIdentifier(e.target.value); setBad(null); }}
            onKeyDown={(e) => { if (e.key === "Enter") requestLink(); }} />
          {bad && <span className="err">{bad}</span>}
        </div>
        <button className="cb-btn wide" style={{ marginTop: 14 }} disabled={busy}
          onClick={requestLink}>{busy ? "Sending…" : "Email me a reset link"}</button>
      </>
    ));

  if (!link) return shell("Set a new password", "Checking your reset link…", null);
  if (link.dead) return shell("Set a new password", "This link cannot be used.",
    <div className="cb-note bad" role="alert">{link.dead}</div>);

  return shell("Set a new password", "Choose a new password for " + link.name + ". It must be at least 8 characters.",
    <>
      <div className="cb-grid">
        <div className="cb-f">
          <label htmlFor="np">New password</label>
          <input id="np" type="password" autoComplete="new-password" value={pw}
            aria-invalid={bad ? "true" : undefined}
            onChange={(e) => { setPw(e.target.value); setBad(null); }} />
        </div>
        <div className="cb-f">
          <label htmlFor="np2">Repeat new password</label>
          <input id="np2" type="password" autoComplete="new-password" value={pw2}
            aria-invalid={bad ? "true" : undefined}
            onChange={(e) => { setPw2(e.target.value); setBad(null); }}
            onKeyDown={(e) => { if (e.key === "Enter") setNewPassword(); }} />
          {bad && <span className="err">{bad}</span>}
        </div>
      </div>
      <button className="cb-btn wide" style={{ marginTop: 14 }} disabled={busy}
        onClick={setNewPassword}>{busy ? "Saving…" : "Set new password"}</button>
    </>);
}

// Logos, lock and heading shared by the sign-in steps.
function AuthShell({ title, lede, children }) {
  return (
    <main className="cb-narrow" style={{ maxWidth: 440, paddingTop: 52 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 18, marginBottom: 18, flexWrap: "wrap" }}>
        {BRAND_IDS.map((id) => (
          <img key={id} src={BRANDS[id].logoDark} alt={BRANDS[id].name} style={{ height: 34, width: "auto" }} />
        ))}
      </div>
      <div style={{ color: "var(--accent)" }}>{I.lock()}</div>
      <h1 className="cb-h1" style={{ marginTop: 10 }}>{title}</h1>
      <p className="cb-lede">{lede}</p>
      <div className="cb-card">{children}</div>
    </main>
  );
}

/* Second sign-in step: the 6-digit code from Google Authenticator (or any
   TOTP app). On someone's first sign-in it shows the QR code to scan first. */
function TotpStep({ twoFa, username, onDone, onRestart }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [bad, setBad] = useState(null);
  const [showKey, setShowKey] = useState(false);
  const setup = twoFa.step === "setup";

  const submit = async () => {
    if (busy) return;
    if (!code.trim()) { setBad("Enter the code from your authenticator app."); return; }
    setBusy(true);
    try { onDone(await registry.verifyLogin(twoFa.pending, code.trim())); }
    catch (e) {
      if (e.restart) { onRestart(e.message); return; }
      setBad(e.message); setCode(""); setBusy(false);
    }
  };

  const codeField = (
    <div className="cb-f">
      <label htmlFor="otp">{setup ? "6-digit code from the app" : "Authenticator code"}</label>
      <input id="otp" inputMode={setup ? "numeric" : "text"} autoComplete="one-time-code" autoFocus
        maxLength={setup ? 6 : 11} value={code} aria-invalid={bad ? "true" : undefined}
        style={{ fontFamily: "var(--mono)", fontSize: 20, letterSpacing: 4, textAlign: "center" }}
        onChange={(e) => { setCode(e.target.value); setBad(null); }}
        onKeyDown={(e) => { if (e.key === "Enter") submit(); }} />
      {bad && <span className="err">{bad}</span>}
    </div>
  );
  const buttons = (
    <>
      <button className="cb-btn wide" style={{ marginTop: 14 }} disabled={busy} onClick={submit}>
        {busy ? "Checking…" : setup ? "Turn on and sign in" : "Sign in"}</button>
      <button type="button" className="cb-textlink" style={{ marginTop: 12 }} onClick={() => onRestart()}>
        Cancel</button>
    </>
  );

  if (!setup) return (
    <AuthShell title="Enter your code"
      lede={"Open Google Authenticator and enter the 6-digit code for Vendor Portal (" + username.trim().toLowerCase() + ")."}>
      {codeField}
      <p className="cb-hint" style={{ marginTop: 8 }}>Lost your phone? Enter one of your backup codes instead, such as abcde-fghjk.</p>
      {buttons}
    </AuthShell>
  );

  return (
    <AuthShell title="Set up Google Authenticator"
      lede="Every account now needs a code from an authenticator app as well as the password. This takes a minute, once.">
      <ol style={{ margin: "0 0 14px", paddingLeft: 20, fontSize: 14, lineHeight: 1.6 }}>
        <li>Install <b>Google Authenticator</b> on your phone (or Microsoft Authenticator / Authy).</li>
        <li>In the app tap <b>+</b>, then <b>Scan a QR code</b>, and scan this:</li>
      </ol>
      <div style={{ display: "grid", placeItems: "center", margin: "4px 0 10px" }}>
        <img src={twoFa.qr} alt="QR code to add Vendor Portal to your authenticator app"
          width={200} height={200} style={{ background: "#fff", padding: 8, borderRadius: 10, border: "1px solid var(--line)" }} />
      </div>
      <div style={{ textAlign: "center", marginBottom: 12 }}>
        {showKey
          ? <span style={{ fontSize: 12.5 }}>Choose <b>Enter a setup key</b>, type:<br />
              <code style={{ fontFamily: "var(--mono)", fontSize: 13, wordBreak: "break-all", userSelect: "all" }}>
                {twoFa.secret.replace(/(.{4})/g, "$1 ").trim()}</code><br />(time-based)</span>
          : <button type="button" className="cb-textlink" onClick={() => setShowKey(true)}>Can't scan? Enter a key instead</button>}
      </div>
      <ol start={3} style={{ margin: "0 0 10px", paddingLeft: 20, fontSize: 14, lineHeight: 1.6 }}>
        <li>Enter the 6-digit code the app now shows for <b>Vendor Portal</b>.</li>
      </ol>
      {codeField}
      {buttons}
    </AuthShell>
  );
}

// Shown once after setup. The server only keeps hashes, so this is the only
// time anyone sees them.
function BackupCodes({ codes, onDone }) {
  const [saved, setSaved] = useState(false);
  const text = "Vendor Portal backup codes — each works once in place of the authenticator code.\n\n" + codes.join("\n");
  return (
    <AuthShell title="Save your backup codes"
      lede="If you lose your phone, each of these lets you sign in once. This is the only time they are shown.">
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 18px", fontFamily: "var(--mono)",
        fontSize: 15, padding: "12px 14px", background: "var(--paper)", borderRadius: 10, marginBottom: 12 }}>
        {codes.map((c) => <span key={c}>{c}</span>)}
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        <button className="cb-btn ghost sm" onClick={() => copyToClipboard(text)}>Copy</button>
        <button className="cb-btn ghost sm" onClick={() => {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
          a.download = "vendor-portal-backup-codes.txt";
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(() => URL.revokeObjectURL(a.href), 10000);
        }}>Download</button>
        <button className="cb-btn ghost sm" onClick={() => window.print()}>Print</button>
      </div>
      <label style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 13.5, cursor: "pointer" }}>
        <input type="checkbox" checked={saved} onChange={(e) => setSaved(e.target.checked)} style={{ marginTop: 3 }} />
        I have saved these codes somewhere safe, away from my phone.
      </label>
      <button className="cb-btn wide" style={{ marginTop: 14 }} disabled={!saved} onClick={onDone}>Continue to the panel</button>
    </AuthShell>
  );
}

function Admin() {
  const [user, setUser] = useState(null);
  const [departments, setDepartments] = useState(["Finance", "IT"]);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [bad, setBad] = useState(null);
  const [busy, setBusy] = useState(false);
  const [checking, setChecking] = useState(true);
  // A "forgot password" email links to /admin?reset=<token>.
  const [resetToken] = useState(() => {
    try { return new URLSearchParams(window.location.search).get("reset") || ""; } catch (e) { return ""; }
  });
  const [mode, setMode] = useState(resetToken ? "reset" : "signin");   // signin | forgot | reset
  const [notice, setNotice] = useState(null);
  const backToSignIn = (message) => {
    // Drop ?reset= so a reload or a bookmark does not reopen a spent link.
    try { window.history.replaceState(null, "", window.location.pathname); } catch (e) { /* old browser */ }
    setMode("signin"); setNotice(message || null); setBad(null);
  };

  // A session cookie survives a reload, so do not make a reviewer sign in
  // again on every refresh.
  useEffect(() => {
    registry.session()
      .then((r) => {
        // Only trust a session that names a real user.
        if (r.user && r.user.username) setUser(r.user);
        if (r.departments) setDepartments(r.departments);
      })
      .catch(() => {})
      .finally(() => setChecking(false));
  }, []);

  // Second step: { step: "code" | "setup", pending, secret?, qr? } after a right password.
  const [twoFa, setTwoFa] = useState(null);
  // Shown once, straight after setting up the authenticator.
  const [freshCodes, setFreshCodes] = useState(null);

  const signIn = async () => {
    if (busy) return;
    setBusy(true);
    try { setTwoFa(await registry.login(username, password)); setPassword(""); setBad(null); setNotice(null); }
    catch (err) { setBad(err.message || "Wrong username or password."); }
    finally { setBusy(false); }
  };

  const finishSignIn = (r) => {
    setTwoFa(null);
    if (r.backupCodes) { setFreshCodes({ codes: r.backupCodes, user: r.user }); return; }
    if (typeof r.backupCodesLeft === "number") {
      window.alert("You signed in with a backup code. " + r.backupCodesLeft + " left." +
        (r.backupCodesLeft <= 2 ? " Ask your administrator to reset your authenticator to get new ones." : ""));
    }
    setUser(r.user);
  };

  const signOut = async () => {
    try { await registry.logout(); } catch (e) { /* sign out locally regardless */ }
    setUser(null); setUsername(""); setPassword("");
  };

  if (checking) return <main className="cb-wrap"><div className="cb-empty">Checking your session…</div></main>;

  if (!user && freshCodes) return (
    <BackupCodes codes={freshCodes.codes} onDone={() => { setUser(freshCodes.user); setFreshCodes(null); }} />
  );

  if (!user && twoFa) return (
    <TotpStep twoFa={twoFa} username={username} onDone={finishSignIn}
      onRestart={(message) => { setTwoFa(null); setBad(message || null); }} />
  );

  if (!user && mode !== "signin") return (
    <PasswordHelp mode={mode} token={resetToken} onBack={backToSignIn} />
  );

  if (!user) return (
    <main className="cb-narrow" style={{ maxWidth: 420, paddingTop: 52 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 18, marginBottom: 18, flexWrap: "wrap" }}>
        {BRAND_IDS.map((id) => (
          <img key={id} src={BRANDS[id].logoDark} alt={BRANDS[id].name} style={{ height: 34, width: "auto" }} />
        ))}
      </div>
      <div style={{ color: "var(--accent)" }}>{I.lock()}</div>
      <h1 className="cb-h1" style={{ marginTop: 10 }}>Procurement sign in</h1>
      <p className="cb-lede">One panel for every brand. Sign in to review and approve vendors for your stage.</p>
      {notice && <div className="cb-note ok" role="status" style={{ marginBottom: 14 }}>{notice}</div>}
      <div className="cb-card">
        <div className="cb-grid">
          <div className="cb-f">
            <label htmlFor="u">Username</label>
            <input id="u" autoComplete="username" value={username} aria-invalid={bad ? "true" : undefined}
              onChange={(e) => { setUsername(e.target.value); setBad(null); }}
              onKeyDown={(e) => { if (e.key === "Enter") signIn(); }} />
          </div>
          <div className="cb-f">
            <label htmlFor="pw">Password</label>
            <input id="pw" type="password" autoComplete="current-password" value={password}
              aria-invalid={bad ? "true" : undefined}
              onChange={(e) => { setPassword(e.target.value); setBad(null); }}
              onKeyDown={(e) => { if (e.key === "Enter") signIn(); }} />
            {bad && <span className="err">{bad}</span>}
          </div>
        </div>
        <button className="cb-btn wide" style={{ marginTop: 14 }} disabled={busy}
          onClick={signIn}>{busy ? "Signing in…" : "Sign in"}</button>
        <button type="button" className="cb-textlink" style={{ marginTop: 12 }}
          onClick={() => { setMode("forgot"); setNotice(null); setBad(null); }}>Forgot password?</button>
      </div>
      <p className="cb-hint">Approval runs in order — {departments.join(", then ")}, whose approval
        creates the vendor. Ask your administrator for an account.</p>
    </main>
  );

  return <AdminShell user={user} departments={departments} onChainChanged={setDepartments} onSignOut={signOut}
    onSessionLost={() => setUser(null)} />;
}

/* ---------- the shell: sidebar, topbar, view switch ---------- */

const VIEWS = [
  { id: "register", label: "Vendor Register", icon: "clip", crumb: "Dashboard",
    title: "Vendor Register Dashboard",
    sub: "Review, verify and manage vendor submissions and supporting documents." },
  { id: "all", label: "All Vendors", icon: "people", crumb: "All Vendors",
    title: "All Vendors", sub: "Every submission across both brands." },
  { id: "approvals", label: "Approvals", icon: "stamp", crumb: "Approvals",
    title: "Awaiting Your Approval", sub: "Vendors sitting at your stage of the chain." },
  { id: "documents", label: "Documents", icon: "folder", crumb: "Documents",
    title: "Documents", sub: "Every file filed with a vendor registration." },
  { id: "links", label: "Forms & Links", icon: "link", crumb: "Forms & Links",
    title: "Forms & Links", sub: "The vendor registration form for each brand." },
  { id: "users", label: "Users", icon: "cog", crumb: "Users",
    title: "Reviewers", sub: "Who signs off, and in what order." },
];

function AdminShell({ user, departments, onChainChanged, onSignOut, onSessionLost }) {
  const [view, setView] = useState("register");
  const [vendors, setVendors] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [sel, setSel] = useState(null);
  const [brandId, setBrandId] = useState(DEFAULT_BRAND);
  const [navOpen, setNavOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [pwOpen, setPwOpen] = useState(false);
  const [bellOpen, setBellOpen] = useState(false);
  const [deciding, setDeciding] = useState(false);

  const load = useCallback(async () => {
    try { setVendors(await registry.list()); setLoadError(null); }
    catch (err) {
      // The session expired or was signed out elsewhere. Showing the shell
      // with an error in it is worse than useless — drop back to sign-in.
      if (err.status === 401) { onSessionLost(); return; }
      setLoadError(err.message); setVendors([]);
    }
  }, [onSessionLost]);
  useEffect(() => { load(); }, [load]);

  const decide = async (v, decision, note) => {
    setDeciding(true);
    try {
      const updated = await registry.decide(v.id, decision, note);
      setVendors((p) => p.map((x) => (x.id === v.id ? updated : x)));
      setSel(updated);
    } catch (err) { alert(err.message); }
    finally { setDeciding(false); }
  };

  const remove = async (v) => {
    try { await registry.remove(v.id); }
    catch (err) { alert(err.message || "The record could not be deleted."); return; }
    setVendors((p) => p.filter((x) => x.id !== v.id));
    setSel(null);
  };

  // `vendors` is null until the first load; memoise the empty case so the
  // derived lists below do not recompute on every render.
  const all = useMemo(() => vendors || [], [vendors]);
  // Everything waiting on this reviewer, across both brands — drives the
  // sidebar count and the bell badge.
  const mine = useMemo(
    () => all.filter((v) => v.currentStage === user.department),
    [all, user.department]);
  // What this reviewer has not looked at since it last changed. Drives the
  // bell badge and the tinted rows; it is per-user, so clearing yours does not
  // clear anyone else's.
  const unread = useMemo(() => all.filter((v) => v.unread), [all]);

  // Opening a record clears it. Update locally first so the badge responds at
  // once, then tell the server.
  const openVendor = (v) => {
    setSel(v);
    if (!v.unread) return;
    setVendors((p) => p.map((x) => (x.id === v.id ? { ...x, unread: false } : x)));
    registry.markRead(v.id).catch(() => load());
  };

  const clearAll = async () => {
    setVendors((p) => p.map((x) => ({ ...x, unread: false })));
    try { await registry.markAllRead(); } catch (e) { load(); }
  };

  const meta = VIEWS.find((x) => x.id === view) || VIEWS[0];
  const go = (id) => { setView(id); setSel(null); setNavOpen(false); };
  // Views that deliberately span both brands keep the house palette; the
  // brand-scoped ones take that brand's mark and accent.
  const scoped = view === "register";
  const shellBrand = BRANDS[scoped ? brandId : DEFAULT_BRAND];

  return (
    <div className="ad" style={scoped ? shellBrand.theme : BRANDS[DEFAULT_BRAND].theme}>
      {navOpen && <div className="ad-scrim" onClick={() => setNavOpen(false)} />}

      <nav className={"ad-side" + (navOpen ? " open" : "")} aria-label="Sections">
        <div className="ad-brandbox">
          <img src={shellBrand.logoLight} alt={shellBrand.name} />
        </div>
        <div className="ad-navlabel">Procurement</div>
        <div className="ad-nav">
          {VIEWS.map((v) => (
            <button key={v.id} className="ad-navitem" aria-current={view === v.id ? "true" : "false"}
              onClick={() => go(v.id)}>
              {I[v.icon]()}
              <span>{v.label}</span>
              {v.id === "approvals" && mine.length > 0 && <span className="cnt">{mine.length}</span>}
            </button>
          ))}
        </div>
        <div className="ad-copy">© {new Date().getFullYear()} {shellBrand.name}<br />All rights reserved.</div>
      </nav>

      <div className="ad-main">
        <header className="ad-top">
          <button className="ad-burger" aria-label="Menu" onClick={() => setNavOpen(true)}>{I.menu()}</button>
          <div className="ad-crumb">
            <span>Procurement</span>{I.chev({ style: { transform: "rotate(-90deg)", width: 13, height: 13 } })}
            {scoped && <><span>{shellBrand.name}</span>
              {I.chev({ style: { transform: "rotate(-90deg)", width: 13, height: 13 } })}</>}
            <b>{meta.crumb}</b>
          </div>
          <button className="ad-bell" aria-expanded={bellOpen}
            aria-label={unread.length ? `${unread.length} unread` : "No unread vendors"}
            onClick={() => { setBellOpen((o) => !o); setMenuOpen(false); }}>
            {I.bell()}{unread.length > 0 && <span className="n">{unread.length}</span>}
          </button>
          {bellOpen && (
            <div className="ad-notif">
              <div className="hd">
                <b>{unread.length ? `${unread.length} unread` : "Nothing new"}</b>
                {unread.length > 0 && (
                  <button className="cb-btn ghost sm" onClick={() => { clearAll(); setBellOpen(false); }}>
                    Mark all read
                  </button>
                )}
                <button className="cb-btn ghost sm" aria-label="Close"
                  onClick={() => setBellOpen(false)}>{I.x()}</button>
              </div>
              <div className="list">
                {unread.length === 0 && (
                  <div className="none">You are up to date. New submissions and decisions show up here.</div>
                )}
                {unread.slice(0, 12).map((v) => (
                  <button className="row" key={v.id}
                    onClick={() => { setBellOpen(false); setView("register"); setBrandId(brandOf(v)); openVendor(v); }}>
                    <b>{(v.data || {}).firmName || v.reference}</b>
                    <span>
                      {BRANDS[brandOf(v)].name} · {v.currentStage
                        ? (v.currentStage === user.department ? "waiting on you" : "with " + v.currentStage)
                        : v.status}
                      {" · " + new Date(v.lastActivityAt).toLocaleString()}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          )}
          <div className="ad-divider" />
          <button className="ad-who" onClick={() => setMenuOpen((o) => !o)} aria-expanded={menuOpen}>
            <span><b>{user.name}</b><span>{user.department}</span></span>
            {I.chev()}
          </button>
          {menuOpen && (
            <div className="ad-menu" onMouseLeave={() => setMenuOpen(false)}>
              <div className="hd">
                <b>{user.name}</b>
                <span>{user.department} · {user.username}{user.role === "admin" ? " · admin" : ""}</span>
              </div>
              <button onClick={() => { setMenuOpen(false); setPwOpen(true); }}>Change my password</button>
              {user.role === "admin" && (
                <button onClick={() => { setMenuOpen(false); go("users"); }}>Manage users</button>
              )}
              <button onClick={() => { setMenuOpen(false); load(); }}>Refresh records</button>
              <button onClick={onSignOut}>Sign out</button>
            </div>
          )}
        </header>

        <div className="ad-body">
          {loadError ? (
            <>
              <div className="cb-note bad">{loadError}</div>
              <div className="cb-navbar"><button className="cb-btn ghost" onClick={load}>Try again</button></div>
            </>
          ) : vendors === null ? (
            <div className="ad-blank"><b>Loading vendor records…</b></div>
          ) : (
            <>
              <div className="ad-head">
                <div style={{ marginRight: "auto" }}>
                  <h1 className="ad-h1">{meta.title}</h1>
                  <p className="ad-sub">{meta.sub}</p>
                </div>
                {(view === "register" || view === "all") && (
                  <a className="cb-btn" href={brandLink(view === "all" ? DEFAULT_BRAND : brandId)}
                    target="_blank" rel="noopener noreferrer">{I.plus()} Add Vendor</a>
                )}
              </div>

              {pwOpen && <ChangePassword user={user} onClose={() => setPwOpen(false)} />}

              {view === "links" ? <LinksView />
                : view === "users" ? <UsersView user={user} onChainChanged={onChainChanged} />
                : view === "documents" ? <DocumentsView vendors={all} />
                : <RegisterView
                    view={view} vendors={all} mine={mine} user={user} departments={departments}
                    brandId={brandId} setBrandId={setBrandId} sel={sel} setSel={setSel} onOpen={openVendor}
                    deciding={deciding} onDecide={decide} onRemove={remove} onRefresh={load} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ---------- register / all vendors / approvals ---------- */

function RegisterView({ view, vendors, mine, user, departments, brandId, setBrandId,
  sel, setSel, onOpen, deciding, onDecide, onRemove, onRefresh }) {
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("all");
  const [brandMenu, setBrandMenu] = useState(false);
  const brand = BRANDS[brandId];
  const scoped = view === "register";

  const pool = view === "approvals" ? mine
    : scoped ? vendors.filter((v) => brandOf(v) === brandId)
    : vendors;

  const shown = useMemo(() => {
    const s = q.trim().toLowerCase();
    return pool.filter((v) => {
      if (status !== "all" && v.status !== status) return false;
      if (!s) return true;
      const d = v.data || {};
      return [v.reference, d.firmName, d.gstNo, d.vatNo, d.panNo, d.city, d.country, d.email, d.items, kindOf(v)]
        .join(" ").toLowerCase().includes(s);
    });
  }, [pool, q, status]);

  const count = (st) => pool.filter((v) => v.status === st).length;

  return (
    <>
      <div className="ad-stats">
        <button className="ad-stat" aria-pressed={status === "all"} onClick={() => setStatus("all")}>
          <span className="ico blue">{I.people()}</span>
          <span><b>{pool.length}</b><span className="lb">Total Vendors</span>
            <div className="sb">{scoped ? "This brand" : "All brands"}</div></span>
        </button>
        <button className="ad-stat" aria-pressed={status === "pending"} onClick={() => setStatus("pending")}>
          <span className="ico amber">{I.hourglass()}</span>
          <span><b>{count("pending")}</b><span className="lb">Pending Review</span>
            <div className="sb">Needs attention</div></span>
        </button>
        <button className="ad-stat" aria-pressed={status === "approved"} onClick={() => setStatus("approved")}>
          <span className="ico green">{I.checkc()}</span>
          <span><b>{count("approved")}</b><span className="lb">Approved</span>
            <div className="sb">Vendor created</div></span>
        </button>
        <button className="ad-stat" aria-pressed={status === "rejected"} onClick={() => setStatus("rejected")}>
          <span className="ico red">{I.xc()}</span>
          <span><b>{count("rejected")}</b><span className="lb">Rejected</span>
            <div className="sb">Chain stopped</div></span>
        </button>
      </div>

      <div className="ad-cols">
        <div>
          {scoped && (
            <div className="ad-card">
              <p className="ad-label">Select Brand</p>
              <button className="ad-brandsel" onClick={() => setBrandMenu((o) => !o)} aria-expanded={brandMenu}>
                <img src={brand.logoDark} alt="" />
                <span>{brand.name}</span>
                <span className="cv">{I.chev()}</span>
              </button>
              {brandMenu && (
                <div className="ad-brandmenu">
                  {BRAND_IDS.map((id) => (
                    <button key={id} onClick={() => { setBrandId(id); setSel(null); setBrandMenu(false); }}>
                      <img src={BRANDS[id].logoDark} alt="" />
                      <span>{BRANDS[id].name}</span>
                    </button>
                  ))}
                </div>
              )}
              <p className="ad-label" style={{ margin: "16px 0 6px" }}>Vendor Registration Form</p>
              <div className="cb-hint cb-mono" style={{ wordBreak: "break-all", marginBottom: 10 }}>
                {brandLink(brandId)}
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button className="cb-btn ghost sm" onClick={() => copyToClipboard(brandLink(brandId))}>
                  Copy Link
                </button>
                <a className="cb-btn ghost sm" href={brandLink(brandId)} target="_blank" rel="noopener noreferrer">
                  Open Form {I.ext()}
                </a>
              </div>
            </div>
          )}

          <div className="ad-card">
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 2 }}>
              <p className="ad-label" style={{ margin: 0, marginRight: "auto" }}>Vendors ({shown.length})</p>
              <button className="ad-iconbtn" title="Refresh" aria-label="Refresh" onClick={onRefresh}>
                {I.circle()}
              </button>
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
              <div className="ad-search">
                {I.search({ style: { color: "var(--ink-3)", flex: "none" } })}
                <input value={q} onChange={(e) => setQ(e.target.value)}
                  placeholder="Search vendors…" aria-label="Search vendors" />
              </div>
              <button className="ad-iconbtn" aria-pressed={status !== "all"} title="Clear status filter"
                aria-label="Clear status filter" onClick={() => setStatus("all")}>{I.filter()}</button>
            </div>

            <div className="ad-vlist">
              {shown.length === 0 && (
                <div className="ad-blank" style={{ padding: "28px 16px" }}>
                  <b>Nothing here yet</b>
                  <span>{pool.length === 0
                    ? (view === "approvals"
                        ? "No vendor is waiting on " + user.department + " right now."
                        : "Share the registration form and submissions land here.")
                    : "No vendor matches this search or filter."}</span>
                </div>
              )}
              {shown.map((v) => (
                <VendorRow key={v.id} v={v} active={sel && sel.id === v.id}
                  showBrand={!scoped} onOpen={() => onOpen(v)} />
              ))}
            </div>
          </div>
        </div>

        <div>
          {sel ? (
            <Detail v={sel} user={user} departments={departments} deciding={deciding}
              onBack={() => setSel(null)} onDecide={onDecide} onRemove={onRemove} />
          ) : (
            <div className="ad-card">
              <div className="ad-blank">
                <span className="ico">{I.clip()}</span>
                <b>Pick a vendor</b>
                <span>Select a record on the left to see its details, documents and approval chain.</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function VendorRow({ v, active, showBrand, onOpen }) {
  const d = v.data || {};
  return (
    <button className={"ad-vitem" + (v.unread ? " unread" : "")}
      aria-current={active ? "true" : "false"} onClick={onOpen}>
      <div className="top">
        <span className="nm">{d.firmName || "Unnamed firm"}</span>
        {kindOf(v) === "international" && <span className="ad-pill intl">International</span>}
        <span className={"ad-pill " + v.status}>{v.status}</span>
      </div>
      <div className="meta cb-mono">{d.gstNo || d.vatNo || d.panNo || "No Tax ID"}</div>
      <div className="meta">
        {[showBrand && BRANDS[brandOf(v)].name, d.city].filter(Boolean).join(" · ")}
        {(showBrand || d.city) && " · "}
        Submitted: {new Date(v.submittedAt).toLocaleDateString()}
      </div>
    </button>
  );
}

/* ---------- vendor detail ---------- */

function Detail({ v, user, departments, deciding, onBack, onDecide, onRemove }) {
  const [tab, setTab] = useState("details");
  const [busy, setBusy] = useState(null);
  const [note, setNote] = useState("");
  const d = v.data || {};
  const brand = BRANDS[brandOf(v)];
  const wasAuto = (k) => (v.autoFilled || []).includes(k);
  const by = {};
  for (const a of v.approvals || []) by[a.department] = a;
  const chain = v.chain && v.chain.length ? v.chain : departments;
  const myTurn = v.currentStage === user.department;
  const isFinal = chain[chain.length - 1] === user.department;
  const laterActed = chain.includes(user.department) && chain
    .slice(chain.indexOf(user.department) + 1).some((x) => by[x]);
  const contact = (d.people || []).map((p) => p.name).filter(Boolean)[0] || d.signatory || "—";
  const intl = kindOf(v) === "international";

  const fetchDoc = async (meta, download) => {
    setBusy(meta.id);
    try {
      const r = await fetch(registry.documentUrl(v.id, meta.id, download), { credentials: "same-origin" });
      if (!r.ok) throw new Error("unavailable");
      const url = URL.createObjectURL(await r.blob());
      const a = document.createElement("a");
      a.href = url;
      if (download) a.download = meta.name; else a.target = "_blank";
      a.rel = "noopener";
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { alert("This file could not be opened. Ask the vendor to re-send it."); }
    finally { setBusy(null); }
  };


  return (
    <div className="ad-card ad-record">
      <img className="cb-printmark" src={brand.logoDark} alt={brand.name} style={{ height: 56, width: "auto" }} />

      <div className="ad-dhead cb-noprint">
        <h2>{d.firmName || "Unnamed firm"}</h2>
        <button className="cb-btn ghost sm cb-back" onClick={onBack}>{I.left()} Back</button>
        <button className="cb-btn ghost sm" onClick={() => window.print()}>{I.printer()} Print Form</button>
        <button className="cb-btn ghost sm" style={{ color: "var(--red)" }}
          onClick={() => { if (window.confirm("Delete this vendor record and its documents? This cannot be undone.")) onRemove(v); }}>
          {I.trash()} Delete
        </button>
      </div>

      <div className="ad-dmeta">
        <span className={"ad-pill " + v.status} style={{ marginLeft: 0 }}>{v.status}</span>
        <span className={"ad-pill " + (intl ? "intl" : "domestic")} style={{ marginLeft: 0 }}>
          {intl ? "International" : "Domestic"}</span>
        <span className="cb-mono">{v.reference}</span>
        <span>Submitted on {new Date(v.submittedAt).toLocaleString()}</span>
      </div>

      <dl className="ad-strip">
        {intl
          ? <div><dt>VAT / TIN</dt><dd className="cb-mono" title={d.vatNo}>{d.vatNo || "—"}</dd></div>
          : <div><dt>GSTIN</dt><dd className="cb-mono" title={d.gstNo}>{d.gstNo || "—"}</dd></div>}
        <div><dt>Location</dt><dd title={[d.city, intl && d.country].filter(Boolean).join(", ")}>
          {[d.city, intl && d.country].filter(Boolean).join(", ") || "—"}</dd></div>
        <div><dt>Submitted By</dt><dd title={contact}>{contact}</dd></div>
        <div><dt>Documents</dt><dd>{(v.docs || []).length}</dd></div>
        <div><dt>Reference ID</dt><dd className="cb-mono" title={v.reference}>{v.reference}</dd></div>
      </dl>

      <div className="ad-split">
        <div className="ad-card" style={{ margin: 0 }}>
          <p className="ad-label">Approval Chain</p>
          <ul className="ad-chain">
            <li className="done">
              <span className="mk">{I.check({ width: 13, height: 13 })}</span>
              <div>
                <div className="ttl">Submitted</div>
                <div className="when">{new Date(v.submittedAt).toLocaleString()}</div>
              </div>
            </li>
            {chain.map((dep) => {
              const a = by[dep];
              const here = v.currentStage === dep;
              const cls = a ? (a.decision === "approved" ? "done" : "no") : here ? "now" : "";
              return (
                <li key={dep} className={cls}>
                  <span className="mk">
                    {a
                      ? (a.decision === "approved" ? I.check({ width: 13, height: 13 }) : I.x({ width: 12, height: 12 }))
                      : I.circle({ width: 9, height: 9 })}
                  </span>
                  <div>
                    <div className="ttl">
                      {dep}
                      {dep === user.department && <span className="you">YOU</span>}
                    </div>
                    <div className="when">
                      {a
                        ? `${a.decision === "approved" ? "Approved" : "Rejected"} on ${new Date(a.decidedAt).toLocaleString()}`
                        : here ? "With them now" : "Not yet reached"}
                    </div>
                    {a && a.note && (
                      <div className="why">Reason: <i>{a.note}</i></div>
                    )}
                    {a && <div className="when">by {a.decidedBy}</div>}
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="cb-noprint" style={{ marginTop: 16 }}>
            {myTurn ? (
              <>
                <div className="cb-f">
                  <label htmlFor="dnote">Note (optional)</label>
                  <input id="dnote" value={note} placeholder="Reason or condition"
                    onChange={(e) => setNote(e.target.value)} />
                </div>
                <div className="cb-navbar" style={{ flexWrap: "wrap" }}>
                  <button className="cb-btn sm" disabled={deciding}
                    onClick={() => { onDecide(v, "approved", note); setNote(""); }}>
                    {I.check()} {isFinal ? "Approve & create vendor" : "Approve"}
                  </button>
                  <button className="cb-btn ghost sm" disabled={deciding}
                    onClick={() => { onDecide(v, "rejected", note); setNote(""); }}>Reject</button>
                </div>
                {isFinal && <p className="cb-hint" style={{ marginTop: 6 }}>
                  Final stage — approving here creates the vendor in the system.
                </p>}
              </>
            ) : (
              <div className={"cb-note " + (v.status === "pending" ? "info" : v.status === "approved" ? "ok" : "bad")}>
                {v.currentStage
                  ? `Waiting on ${v.currentStage}.`
                  : `This vendor is ${v.status} — the chain is finished.`}
              </div>
            )}
            {by[user.department] && !laterActed && (
              <div className="cb-navbar">
                <button className="cb-btn ghost sm" disabled={deciding}
                  onClick={() => onDecide(v, "clear", "")}>
                  {by[user.department].decision === "rejected" ? "Reopen review" : "Withdraw my approval"}
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="ad-card" style={{ margin: 0 }}>
          <div className="ad-tabs cb-noprint" role="tablist">
            <button role="tab" aria-selected={tab === "details"} onClick={() => setTab("details")}>Details</button>
            <button role="tab" aria-selected={tab === "docs"} onClick={() => setTab("docs")}>
              Documents ({(v.docs || []).length})
            </button>
          </div>

          {tab === "details" && (
            <>
              <Block title="Company">
                <Row k="Firm" v={d.firmName} />
                <Row k="Address" v={[d.address, d.city, d.state, d.pincode, d.country].filter(Boolean).join(", ")} />
                <Row k="Email" v={d.email} /><Row k="Mobile" v={d.mobile} />
                <Row k="Telephone" v={d.phone} /><Row k="Website" v={d.website} />
              </Block>
              <Block title="People to contact">
                {(d.people || []).filter((p) => p.name).map((p, i) => (
                  <Row key={i} k={p.designation || "Contact"}
                    v={[p.name, p.qualification, p.phone, p.place].filter(Boolean).join(" · ")} />
                ))}
              </Block>
              <Block title="Business">
                <Row k="Nature of business" v={d.natureBusiness} />
                <Row k="Nature of company" v={d.natureCompany} />
                <Row k="Size" v={d.size} /><Row k="Items / services" v={d.items} />
                <Row k="Reason for creation" v={d.reason} />
                <Row k={"Relation with " + brand.name + " staff"} v={d.relation} />
              </Block>
              {intl ? (
                <Block title="Tax and compliance">
                  <Row k="PE in India" v={d.peStatus === "yes" ? "Yes — PAN mandatory" : d.peStatus === "no" ? "No" : ""} />
                  <Row k="VAT / TIN" v={d.vatNo ? d.vatNo + (wasAuto("vatNo") ? "  (read from document)" : "") : ""} />
                  <Row k="VAT registration date" v={d.vatDate} />
                  <Row k="PAN" v={d.panNo ? d.panNo + (wasAuto("panNo") ? "  (read from document)" : "") : ""} />
                  <Row k="GST dealer type" v={d.gstDealer || "Not registered in India"} />
                  <Row k="Size" v={d.size} />
                  <Row k="Enterprise reg." v={[d.udyamNo, d.udyamDate].filter(Boolean).join(" · ")} />
                  <Row k="Certified" v={d.certified === "yes" ? d.certTypes || "Yes"
                    : d.certInProcess === "yes" ? "In process, expected " + (d.certExpected || "—") : "No"} />
                  {d.itExNo && <Row k="IT exemption" v={[d.itSection && "Sec " + d.itSection, d.itExNo, d.itExRate && d.itExRate + "%",
                    [d.itExFrom, d.itExTo].filter(Boolean).join(" to ")].filter(Boolean).join(" · ")} />}
                </Block>
              ) : (
                <Block title="Tax and compliance">
                  <Row k="PAN" v={d.panNo ? d.panNo + (wasAuto("panNo") ? "  (read from document)" : "") : ""} />
                  <Row k="GSTIN" v={d.gstNo ? d.gstNo + (wasAuto("gstNo") ? "  (read from document)" : "") : ""} />
                  <Row k="GST dealer type" v={d.gstDealer} />
                  <Row k="Udyam / enterprise reg." v={d.udyamNo} />
                  <Row k="Foreign entity" v={d.isForeign === "yes" ? "Yes · PE status: " + (d.peStatus || "not stated") : "No"} />
                  <Row k="Certified" v={d.certified === "yes" ? d.certTypes || "Yes"
                    : d.certInProcess === "yes" ? "In process, expected " + (d.certExpected || "—") : "No"} />
                </Block>
              )}
              {intl ? (
                <Block title="Bank">
                  <Row k="Bank" v={d.bankName} />
                  <Row k="Bank address" v={d.bankAddress} />
                  <Row k="Account holder" v={d.accountHolder} />
                  <Row k="Account number" v={d.bankAccount} />
                  <Row k="SWIFT / BIC" v={d.swift} /><Row k="IBAN" v={d.iban} />
                  <Row k="Bank country" v={d.bankCountry} />
                </Block>
              ) : (
                <Block title="Bank">
                  <Row k="Bank" v={[d.bankName, d.branch].filter(Boolean).join(", ")} />
                  <Row k="Account holder" v={d.accountHolder} />
                  <Row k="Account number" v={d.bankAccount} /><Row k="IFSC" v={d.ifsc} />
                  {d.swift && <Row k="SWIFT" v={d.swift} />}{d.iban && <Row k="IBAN" v={d.iban} />}
                </Block>
              )}
              <Block title="Declaration">
                <Row k="Signed by" v={d.signatory} /><Row k="Place" v={d.declPlace} />
                <Row k="Date" v={d.declDate} />
                <Row k="Confirmed" v={d.agreed ? "Yes — declaration accepted at submission" : "No"} />
              </Block>
            </>
          )}

          {tab === "docs" && intl && missingIntlDocs(v.docs || []).length > 0 && (
            <div className="cb-note warn" style={{ marginBottom: 12, display: "block" }}>
              <b>Still needed from this vendor:</b> {missingIntlDocs(v.docs || []).join(", ")}.
            </div>
          )}
          {tab === "docs" && (
            (v.docs || []).length === 0 ? (
              <div className="ad-blank">
                <span className="ico">{I.folder({ width: 24, height: 24 })}</span>
                <b>No documents uploaded</b>
                <span>No documents were submitted by this vendor.</span>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
                {(v.docs || []).map((f) => (
                  <div className="cb-doc" key={f.id}>
                    <div className="ico" style={{ width: 34, height: 34, borderRadius: 8,
                      background: "var(--accent-tint)", color: "var(--accent)", display: "grid",
                      placeItems: "center", flex: "none" }}>{I.file()}</div>
                    {/* A plain link, so the browser opens it as a real new tab (its own
                        PDF/image viewer). The server sends it inline with the session
                        cookie; a blob opened after an await gets popup-blocked. */}
                    <a href={registry.documentUrl(v.id, f.id)} target="_blank" rel="noopener noreferrer"
                      title={"Open " + f.name + " in a new tab"}
                      style={{ minWidth: 0, flex: 1, color: "inherit", textDecoration: "none" }}>
                      <div style={{ fontSize: 13.5, fontWeight: 600, overflow: "hidden",
                        textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.type}</div>
                      <div style={{ fontSize: 11.5, color: "var(--ink-3)", overflow: "hidden",
                        textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name} · {kb(f.size)}</div>
                    </a>
                    <a className="cb-btn ghost sm" href={registry.documentUrl(v.id, f.id)}
                      target="_blank" rel="noopener noreferrer" aria-label={"Open " + f.name + " in a new tab"}
                      title="Open in new tab">{I.eye()}</a>
                    <button className="cb-btn ghost sm" disabled={busy === f.id}
                      onClick={() => fetchDoc(f, true)} aria-label={"Download " + f.name}>{I.down()}</button>
                  </div>
                ))}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div style={{ marginBottom: 18 }}>
      <div className="cb-card-h"><span className="cb-eyebrow">{title}</span></div>
      <dl className="cb-rows" style={{ margin: 0 }}>{children}</dl>
    </div>
  );
}

/* ---------- simple views ---------- */

function LinksView() {
  return (
    <div className="ad-card">
      <p className="ad-label">Share these with vendors. Each brand has its own form. The main link asks the vendor to
        choose domestic or international; the other two skip that question.</p>
      {BRAND_IDS.map((id) => (
        <div key={id} style={{ marginTop: 14 }}>
          {[[null, "Choose"], ["domestic", "Domestic"], ["international", "International"]].map(([k, label]) => (
            <div key={label} className="cb-link" style={{ marginTop: 6 }}>
              {k === null
                ? <img src={BRANDS[id].logoDark} alt={BRANDS[id].name} style={{ height: 20, width: "auto", flex: "none" }} />
                : <span className="who" style={{ minWidth: 92 }}>{label}</span>}
              <code>{brandLink(id, k)}</code>
              <button className="cb-btn ghost sm" onClick={() => copyToClipboard(brandLink(id, k))}>Copy Link</button>
              <a className="cb-btn ghost sm" href={brandLink(id, k)} target="_blank" rel="noopener noreferrer">
                Open {I.ext()}
              </a>
            </div>
          ))}
        </div>
      ))}
      <div className="cb-link" style={{ marginTop: 18 }}>
        <span className="who">This panel</span>
        <code>{adminLink()}</code>
        <button className="cb-btn ghost sm" onClick={() => copyToClipboard(adminLink())}>Copy Link</button>
      </div>
      <p className="cb-hint" style={{ marginTop: 14 }}>
        Send vendors only their brand's form link — it has no route into this panel.
      </p>
    </div>
  );
}

function UsersView({ user, onChainChanged }) {
  const [dir, setDir] = useState(null);            // { users, departments, chain }
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const blankDraft = { username: "", name: "", email: "", department: "", role: "reviewer", password: "",
    newDept: "", newDeptAt: "end" };
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState(blankDraft);
  const [editing, setEditing] = useState(null);     // { username, name, email, department, role }
  const [resetting, setResetting] = useState(null); // username being reset
  const [newPass, setNewPass] = useState("");
  const [deptForm, setDeptForm] = useState(null);   // { name, at } while adding a department
  const isAdmin = user.role === "admin";

  const load = useCallback(async () => {
    try { setDir(await registry.directory()); setError(null); }
    catch (err) { setError(err.message); setDir({ users: [], departments: [], chain: [] }); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const run = async (fn, done) => {
    setBusy(true); setError(null);
    try {
      const r = await fn();
      await load();
      if (r && r.chain && onChainChanged) onChainChanged(r.chain);
      if (done) done();
    }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };

  if (dir === null) return <div className="ad-card"><div className="ad-blank"><b>Loading reviewers…</b></div></div>;

  const { users, departments, chain } = dir;
  const others = departments.filter((d) => d.position === null).map((d) => d.name);
  const allDepts = [...chain, ...others];

  // "Where does a new stage go" options, shared by both department forms.
  const placementOptions = (
    <>
      {chain.map((dep, i) => (
        <option key={dep} value={String(i + 1)}>Stage {i + 1} — before {dep}</option>
      ))}
      <option value="end">
        Stage {chain.length + 1} — at the end{chain.length ? ` (after ${chain[chain.length - 1]}), becomes the final stage` : ""}
      </option>
      <option value="none">Not an approval stage — department only</option>
    </>
  );
  const placementValue = (at) => (at === "none" ? null : at === "end" ? chain.length + 1 : Number(at));

  const create = () => run(async () => {
    let department = draft.department || allDepts[0];
    if (draft.department === "__new") {
      const name = draft.newDept.trim();
      if (!name) throw new Error("Type a name for the new department.");
      const r = await registry.addDepartment(name, placementValue(draft.newDeptAt));
      department = name;
      await load();
      setDraft((d) => ({ ...d, department: name, newDept: "" }));
      if (onChainChanged) onChainChanged(r.chain);
      await registry.createUser({ ...draft, department });
      return r;
    }
    await registry.createUser({ ...draft, department });
    return null;
  }, () => { setAdding(false); setDraft(blankDraft); });

  const saveEdit = () => run(async () => {
    const { username, ...patch } = editing;
    await registry.updateUser(username, patch);
  }, () => setEditing(null));

  const reset = () => run(async () => {
    await registry.resetPassword(resetting, newPass);
  }, () => { setResetting(null); setNewPass(""); });

  const moveStage = (name, position) => run(() => registry.moveDepartment(name, position));

  const deleteDept = (name) => {
    if (window.confirm(`Delete the ${name} department? This cannot be undone.`)) {
      run(() => registry.removeDepartment(name));
    }
  };

  const addDept = () => run(async () => {
    const name = deptForm.name.trim();
    if (!name) throw new Error("Type a name for the new department.");
    return registry.addDepartment(name, placementValue(deptForm.at));
  }, () => setDeptForm(null));

  const peopleIn = (dep) => users.filter((u) => u.department === dep);

  const userRow = (u) => {
    if (editing && editing.username === u.username) {
      return (
        <div key={u.username} className="cb-card" style={{ margin: "6px 0", background: "var(--ochre-tint)" }}>
          <div className="cb-card-h"><span className="cb-eyebrow">Edit {u.username}</span></div>
          <div className="cb-grid two">
            <div className="cb-f">
              <label htmlFor="en">Full name</label>
              <input id="en" value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} />
            </div>
            <div className="cb-f">
              <label htmlFor="ee">Email</label>
              <input id="ee" type="email" value={editing.email} placeholder="Approval requests go here"
                onChange={(e) => setEditing({ ...editing, email: e.target.value })} />
            </div>
            <div className="cb-f">
              <label htmlFor="ed">Department</label>
              <select id="ed" value={editing.department}
                onChange={(e) => setEditing({ ...editing, department: e.target.value })}>
                {chain.map((d, i) => <option key={d} value={d}>{i + 1}. {d}</option>)}
                {others.map((d) => <option key={d} value={d}>{d} (no sign-off)</option>)}
              </select>
            </div>
            <div className="cb-f">
              <label htmlFor="er">Role</label>
              <select id="er" value={editing.role} onChange={(e) => setEditing({ ...editing, role: e.target.value })}>
                <option value="reviewer">Reviewer — signs off for their stage</option>
                <option value="admin">Administrator — also manages users and stages</option>
              </select>
            </div>
          </div>
          <div className="cb-navbar">
            <button className="cb-btn sm" disabled={busy} onClick={saveEdit}>{busy ? "Saving…" : "Save"}</button>
            <button className="cb-btn ghost sm" disabled={busy}
              onClick={() => { setEditing(null); setError(null); }}>Cancel</button>
          </div>
        </div>
      );
    }
    return (
      <div key={u.username} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", padding: "3px 0" }}>
        <b style={{ fontWeight: 600 }}>{u.name}</b>
        <span className="cb-hint cb-mono">{u.username}</span>
        {u.email
          ? <span className="cb-hint">{u.email}</span>
          : <span className="cb-hint" style={{ color: "var(--red)" }}>no email — will not be notified</span>}
        {u.role === "admin" && <span className="cb-auto">admin</span>}
        {u.username === user.username && <span className="cb-auto">you</span>}
        {!u.active && <span className="ad-pill rejected" style={{ marginLeft: 0 }}>inactive</span>}
        {u.totpEnabledAt
          ? <span className="cb-hint" title={"Authenticator set up " + new Date(u.totpEnabledAt).toLocaleDateString("en-GB")}>
              authenticator on</span>
          : <span className="cb-hint" style={{ color: "var(--ochre)" }}>authenticator: set up at next sign-in</span>}
        {isAdmin && (
          <span style={{ marginLeft: "auto", display: "flex", gap: 6, flexWrap: "wrap" }}>
            {u.totpEnabledAt && (
              <button className="cb-btn ghost sm" disabled={busy}
                onClick={() => {
                  if (window.confirm(`Reset ${u.name}'s authenticator? They are signed out, and at their next ` +
                    "sign-in they scan a new QR code and get new backup codes. Use this for a lost or new phone.")) {
                    run(() => registry.resetTotp(u.username));
                  }
                }}>Reset authenticator</button>
            )}
            <button className="cb-btn ghost sm" disabled={busy}
              onClick={() => {
                setEditing({ username: u.username, name: u.name, email: u.email || "",
                  department: u.department, role: u.role });
                setResetting(null); setError(null);
              }}>Edit</button>
            <button className="cb-btn ghost sm" disabled={busy}
              onClick={() => { setResetting(u.username); setNewPass(""); setEditing(null); setError(null); }}>
              Reset password
            </button>
            <button className="cb-btn ghost sm" disabled={busy}
              onClick={() => run(() => registry.updateUser(u.username, { active: !u.active }))}>
              {u.active ? "Deactivate" : "Reactivate"}
            </button>
            <button className="cb-btn ghost sm" style={{ color: "var(--red)" }} disabled={busy}
              onClick={() => {
                if (window.confirm(`Delete ${u.name}? Their approvals stay on record.`)) {
                  run(() => registry.removeUser(u.username));
                }
              }}>Delete</button>
          </span>
        )}
      </div>
    );
  };

  const deptControls = (dep, i) => isAdmin && (
    <span style={{ display: "inline-flex", gap: 4, marginLeft: 8, flexWrap: "wrap" }} className="cb-noprint">
      {i !== null && (
        <>
          <button className="cb-btn ghost sm" title="Move earlier" disabled={busy || i === 0}
            onClick={() => moveStage(dep, i)}>↑</button>
          <button className="cb-btn ghost sm" title="Move later" disabled={busy || i === chain.length - 1}
            onClick={() => moveStage(dep, i + 2)}>↓</button>
          <button className="cb-btn ghost sm" disabled={busy || chain.length === 1}
            title="New vendors skip this stage; ones already waiting on it can still be finished"
            onClick={() => moveStage(dep, null)}>Remove from chain</button>
        </>
      )}
      {i === null && (
        <button className="cb-btn ghost sm" disabled={busy}
          onClick={() => moveStage(dep, chain.length + 1)}>Add to chain</button>
      )}
      <button className="cb-btn ghost sm" style={{ color: "var(--red)" }} disabled={busy}
        onClick={() => deleteDept(dep)}>{I.trash({ width: 14, height: 14 })}</button>
    </span>
  );

  return (
    <>
      {error && <div className="cb-note bad" style={{ marginBottom: 14 }}>{error}</div>}

      <div className="ad-card">
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4, flexWrap: "wrap" }}>
          <p className="ad-label" style={{ margin: 0, marginRight: "auto" }}>
            Approval runs in this order. Each stage opens once the one before it approves.
          </p>
          {isAdmin && !adding && (
            <>
              <button className="cb-btn ghost sm" disabled={busy}
                onClick={() => { setDeptForm({ name: "", at: "end" }); setError(null); }}>
                {I.plus()} Add department
              </button>
              <button className="cb-btn sm" onClick={() => {
                setAdding(true); setDraft({ ...blankDraft, department: chain[0] || others[0] || "__new" });
              }}>{I.plus()} Add user</button>
            </>
          )}
        </div>

        {deptForm && (
          <div className="cb-card" style={{ marginTop: 12, background: "var(--line-2)" }}>
            <div className="cb-card-h"><span className="cb-eyebrow">New department</span></div>
            <div className="cb-grid two">
              <div className="cb-f">
                <label htmlFor="dn">Department name</label>
                <input id="dn" value={deptForm.name} placeholder="e.g. Purchase, Legal, Quality"
                  onChange={(e) => setDeptForm({ ...deptForm, name: e.target.value })} />
              </div>
              <div className="cb-f">
                <label htmlFor="da">Place in approval chain</label>
                <select id="da" value={deptForm.at} onChange={(e) => setDeptForm({ ...deptForm, at: e.target.value })}>
                  {placementOptions}
                </select>
              </div>
            </div>
            <div className="cb-navbar">
              <button className="cb-btn sm" disabled={busy} onClick={addDept}>{busy ? "Adding…" : "Add department"}</button>
              <button className="cb-btn ghost sm" disabled={busy}
                onClick={() => { setDeptForm(null); setError(null); }}>Cancel</button>
            </div>
          </div>
        )}

        {adding && (
          <div className="cb-card" style={{ marginTop: 12, background: "var(--line-2)" }}>
            <div className="cb-card-h"><span className="cb-eyebrow">New user</span></div>
            <div className="cb-grid two">
              <div className="cb-f">
                <label htmlFor="nu">Username</label>
                <input id="nu" value={draft.username} placeholder="e.g. anjali"
                  onChange={(e) => setDraft({ ...draft, username: e.target.value })} />
                <span className="cb-hint">Lowercase letters, digits, dot, dash or underscore.</span>
              </div>
              <div className="cb-f">
                <label htmlFor="nn">Full name</label>
                <input id="nn" value={draft.name} placeholder="e.g. Anjali Sharma"
                  onChange={(e) => setDraft({ ...draft, name: e.target.value })} />
              </div>
              <div className="cb-f cb-span">
                <label htmlFor="ne">Email</label>
                <input id="ne" type="email" value={draft.email} placeholder="e.g. anjali@modienterprise.com"
                  onChange={(e) => setDraft({ ...draft, email: e.target.value })} />
                <span className="cb-hint">Approval requests for their stage are sent here. Leave blank to skip emails.</span>
              </div>
              <div className="cb-f">
                <label htmlFor="nd">Department</label>
                <select id="nd" value={draft.department}
                  onChange={(e) => setDraft({ ...draft, department: e.target.value })}>
                  {chain.map((d, i) => <option key={d} value={d}>{i + 1}. {d}</option>)}
                  {others.map((d) => <option key={d} value={d}>{d} (no sign-off)</option>)}
                  <option value="__new">+ New department…</option>
                </select>
              </div>
              <div className="cb-f">
                <label htmlFor="nr">Role</label>
                <select id="nr" value={draft.role} onChange={(e) => setDraft({ ...draft, role: e.target.value })}>
                  <option value="reviewer">Reviewer — signs off for their stage</option>
                  <option value="admin">Administrator — also manages users and stages</option>
                </select>
              </div>
              {draft.department === "__new" && (
                <>
                  <div className="cb-f">
                    <label htmlFor="ndn">New department name</label>
                    <input id="ndn" value={draft.newDept} placeholder="e.g. Purchase, Legal, Quality"
                      onChange={(e) => setDraft({ ...draft, newDept: e.target.value })} />
                  </div>
                  <div className="cb-f">
                    <label htmlFor="nda">Place in approval chain</label>
                    <select id="nda" value={draft.newDeptAt}
                      onChange={(e) => setDraft({ ...draft, newDeptAt: e.target.value })}>
                      {placementOptions}
                    </select>
                  </div>
                </>
              )}
              <div className="cb-f cb-span">
                <label htmlFor="np">Temporary password</label>
                <input id="np" type="password" value={draft.password} autoComplete="new-password"
                  onChange={(e) => setDraft({ ...draft, password: e.target.value })} />
                <span className="cb-hint">At least 8 characters. Tell them to change it once they sign in.</span>
              </div>
            </div>
            <div className="cb-navbar">
              <button className="cb-btn sm" disabled={busy} onClick={create}>
                {busy ? "Creating…" : "Create user"}
              </button>
              <button className="cb-btn ghost sm" disabled={busy} onClick={() => { setAdding(false); setError(null); }}>
                Cancel
              </button>
            </div>
          </div>
        )}

        <dl className="cb-rows" style={{ margin: "12px 0 0" }}>
          {chain.map((dep, i) => {
            const inStage = peopleIn(dep);
            return (
              <div className="cb-row" key={dep} style={{ alignItems: "flex-start" }}>
                <dt>
                  <span className="cb-mono" style={{ marginRight: 6 }}>{i + 1}.</span>{dep}
                  {deptControls(dep, i)}
                </dt>
                <dd>
                  {inStage.length === 0 && <span className="cb-hint">Nobody assigned — this stage cannot be signed off.</span>}
                  {inStage.map(userRow)}
                  {i === chain.length - 1 && (
                    <div className="cb-hint" style={{ marginTop: 4 }}>
                      Final stage — creates the vendor in the system.
                    </div>
                  )}
                </dd>
              </div>
            );
          })}
        </dl>

        {others.length > 0 && (
          <>
            <p className="ad-label" style={{ margin: "18px 0 4px" }}>Other departments — no sign-off stage</p>
            <dl className="cb-rows" style={{ margin: 0 }}>
              {others.map((dep) => {
                const inDept = peopleIn(dep);
                return (
                  <div className="cb-row" key={dep} style={{ alignItems: "flex-start" }}>
                    <dt>{dep}{deptControls(dep, null)}</dt>
                    <dd>
                      {inDept.length === 0 && <span className="cb-hint">Nobody in this department yet.</span>}
                      {inDept.map(userRow)}
                    </dd>
                  </div>
                );
              })}
            </dl>
          </>
        )}

        {resetting && (
          <div className="cb-card" style={{ marginTop: 14, background: "var(--ochre-tint)" }}>
            <div className="cb-card-h"><span className="cb-eyebrow">Reset password for {resetting}</span></div>
            <div className="cb-f">
              <label htmlFor="rp">New password</label>
              <input id="rp" type="password" value={newPass} autoComplete="new-password"
                onChange={(e) => setNewPass(e.target.value)} />
              <span className="cb-hint">
                At least 8 characters. This signs them out everywhere — tell them the new password directly,
                not by email.
              </span>
            </div>
            <div className="cb-navbar">
              <button className="cb-btn sm" disabled={busy} onClick={reset}>
                {busy ? "Saving…" : "Set password"}
              </button>
              <button className="cb-btn ghost sm" disabled={busy}
                onClick={() => { setResetting(null); setError(null); }}>Cancel</button>
            </div>
          </div>
        )}

        <p className="cb-hint" style={{ marginTop: 14 }}>
          {isAdmin
            ? "Changes to the stages apply to vendors submitted from now on — vendors already in progress keep the chain they started with. Everyone listed here can see both brands and every vendor's bank details."
            : "Only an administrator can add users, change stages or reset passwords. Change your own password from the menu under your name."}
        </p>
      </div>
    </>
  );
}

/* ---------- change your own password ---------- */

function ChangePassword({ user, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const save = async () => {
    setBusy(true); setError(null);
    try { await registry.changeOwnPassword(user.username, current, next); setDone(true); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="ad-card" style={{ maxWidth: 460, margin: "0 0 16px" }}>
      <div className="cb-card-h"><span className="cb-eyebrow">Change your password</span></div>
      {done ? (
        <>
          <div className="cb-note ok">Password changed. Any other device you were signed in on has been signed out.</div>
          <div className="cb-navbar"><button className="cb-btn ghost sm" onClick={onClose}>Close</button></div>
        </>
      ) : (
        <>
          <div className="cb-grid">
            <div className="cb-f">
              <label htmlFor="cp">Current password</label>
              <input id="cp" type="password" autoComplete="current-password" value={current}
                onChange={(e) => { setCurrent(e.target.value); setError(null); }} />
            </div>
            <div className="cb-f">
              <label htmlFor="npw">New password</label>
              <input id="npw" type="password" autoComplete="new-password" value={next}
                onChange={(e) => { setNext(e.target.value); setError(null); }} />
              <span className="cb-hint">At least 8 characters.</span>
              {error && <span className="err">{error}</span>}
            </div>
          </div>
          <div className="cb-navbar">
            <button className="cb-btn sm" disabled={busy} onClick={save}>{busy ? "Saving…" : "Change password"}</button>
            <button className="cb-btn ghost sm" disabled={busy} onClick={onClose}>Cancel</button>
          </div>
        </>
      )}
    </div>
  );
}

function DocumentsView({ vendors }) {
  const [open, setOpen] = useState(null);        // id of the expanded vendor
  const [query, setQuery] = useState("");
  const [brand, setBrand] = useState("all");
  const [saving, setSaving] = useState(null);    // vendor id while "Download all" runs

  const total = vendors.reduce((n, v) => n + (v.docs || []).length, 0);
  const q = query.trim().toLowerCase();
  const shown = vendors
    .filter((v) => brand === "all" || brandOf(v) === brand)
    .filter((v) => {
      if (!q) return true;
      const d = v.data || {};
      return [d.firmName, v.reference, d.gstNo, d.vatNo, d.panNo, d.city, d.country]
        .some((x) => String(x || "").toLowerCase().includes(q));
    })
    // Vendors with files first, newest first within each group.
    .sort((a, b) => (((b.docs || []).length > 0) - ((a.docs || []).length > 0))
      || String(b.submittedAt).localeCompare(String(a.submittedAt)));

  // One file at a time with a short gap: browsers drop downloads that are
  // fired in the same instant. The first "Download all" may make the browser
  // ask once whether this site may download several files.
  const downloadAll = async (v) => {
    setSaving(v.id);
    try {
      for (const f of v.docs || []) {
        const a = document.createElement("a");
        a.href = registry.documentUrl(v.id, f.id, true);
        a.rel = "noopener";
        document.body.appendChild(a); a.click(); a.remove();
        await new Promise((r) => setTimeout(r, 700));
      }
    } finally { setSaving(null); }
  };

  if (!total) {
    return (
      <div className="ad-card">
        <div className="ad-blank">
          <span className="ico">{I.folder({ width: 24, height: 24 })}</span>
          <b>No documents yet</b>
          <span>Files uploaded with a registration appear here.</span>
        </div>
      </div>
    );
  }

  return (
    <div className="ad-card">
      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
        <p className="ad-label" style={{ margin: 0, marginRight: "auto" }}>
          {total} file{total === 1 ? "" : "s"} across {vendors.length} vendor{vendors.length === 1 ? "" : "s"}
        </p>
        <select value={brand} onChange={(e) => setBrand(e.target.value)} aria-label="Brand"
          style={{ padding: "7px 10px", borderRadius: 8, border: "1px solid var(--line)", background: "var(--card)" }}>
          <option value="all">All brands</option>
          {Object.keys(BRANDS).map((id) => <option key={id} value={id}>{BRANDS[id].name}</option>)}
        </select>
        <input value={query} onChange={(e) => setQuery(e.target.value)} aria-label="Search vendors"
          placeholder="Search firm, reference, GSTIN…"
          style={{ padding: "7px 10px", borderRadius: 8, border: "1px solid var(--line)", minWidth: 220 }} />
      </div>

      {shown.length === 0 && (
        <div className="ad-blank"><b>No vendors match</b><span>Try a different search or brand.</span></div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
        {shown.map((v) => {
          const d = v.data || {};
          const docs = v.docs || [];
          const isOpen = open === v.id;
          return (
            <div key={v.id} style={{ border: "1px solid var(--line)", borderRadius: 11,
              background: isOpen ? "var(--line-2)" : "transparent", overflow: "hidden" }}>
              <button type="button" onClick={() => setOpen(isOpen ? null : v.id)} aria-expanded={isOpen}
                disabled={!docs.length}
                style={{ all: "unset", boxSizing: "border-box", width: "100%", display: "flex", alignItems: "center",
                  gap: 11, padding: "11px 12px", cursor: docs.length ? "pointer" : "default",
                  opacity: docs.length ? 1 : 0.55 }}>
                <span style={{ width: 34, height: 34, borderRadius: 8, background: "var(--accent-tint)",
                  color: "var(--accent)", display: "grid", placeItems: "center", flex: "none" }}>
                  {I.folder()}
                </span>
                <span style={{ minWidth: 0, flex: 1 }}>
                  <span style={{ display: "block", fontSize: 14, fontWeight: 600 }}>
                    {d.firmName || "Unnamed firm"}
                    <span className={"ad-pill " + v.status} style={{ marginLeft: 8, verticalAlign: "middle" }}>{v.status}</span>
                  </span>
                  <span style={{ display: "block", fontSize: 11.5, color: "var(--ink-3)" }}>
                    {BRANDS[brandOf(v)].name} · <span className="cb-mono">{v.reference}</span>
                    {" · "}{new Date(v.submittedAt).toLocaleDateString("en-GB")}
                  </span>
                </span>
                <span style={{ fontSize: 12.5, color: "var(--ink-3)", whiteSpace: "nowrap" }}>
                  {docs.length ? `${docs.length} document${docs.length === 1 ? "" : "s"}` : "No documents"}
                </span>
                {docs.length > 0 && (
                  <span style={{ transform: isOpen ? "rotate(180deg)" : "none", display: "grid", color: "var(--ink-3)" }}>
                    {I.chev()}
                  </span>
                )}
              </button>

              {isOpen && (
                <div style={{ padding: "0 12px 12px", display: "flex", flexDirection: "column", gap: 7 }}>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button className="cb-btn sm" disabled={saving === v.id} onClick={() => downloadAll(v)}>
                      {I.down({ width: 15, height: 15 })} {saving === v.id ? "Downloading…" : `Download all (${docs.length})`}
                    </button>
                  </div>
                  {docs.map((f) => (
                    <div className="cb-doc" key={f.id} style={{ background: "var(--card)" }}>
                      <span style={{ width: 30, height: 30, borderRadius: 7, background: "var(--accent-tint)",
                        color: "var(--accent)", display: "grid", placeItems: "center", flex: "none" }}>{I.file()}</span>
                      <div style={{ minWidth: 0, flex: 1 }}>
                        <div style={{ fontSize: 13.5, fontWeight: 600 }}>{f.type}</div>
                        <div style={{ fontSize: 11.5, color: "var(--ink-3)", overflow: "hidden",
                          textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={f.name}>
                          {f.name} · {kb(f.size)}
                        </div>
                      </div>
                      <a className="cb-btn ghost sm" href={registry.documentUrl(v.id, f.id, false)}
                        target="_blank" rel="noopener noreferrer" aria-label={"View " + f.name} title="View">
                        {I.eye()}
                      </a>
                      <a className="cb-btn ghost sm" href={registry.documentUrl(v.id, f.id, true)}
                        rel="noopener" aria-label={"Download " + f.name} title="Download">
                        {I.down({ width: 16, height: 16 })} Download
                      </a>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
